// Generated by scripts/build-images.mjs. Do not edit by hand.
export const generatedImages = {
  "/img/scenes/s01_dining_tea_service": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s01_dining_tea_service-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s01_dining_tea_service-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s01_dining_tea_service-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s01_dining_tea_service-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s01_dining_tea_service-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s01_dining_tea_service-600.webp"
      }
    ]
  },
  "/img/scenes/s02_dining_afternoon_tea": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s02_dining_afternoon_tea-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s02_dining_afternoon_tea-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s02_dining_afternoon_tea-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s02_dining_afternoon_tea-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s02_dining_afternoon_tea-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s02_dining_afternoon_tea-600.webp"
      }
    ]
  },
  "/img/scenes/s03_dining_table_manners": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s03_dining_table_manners-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s03_dining_table_manners-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s03_dining_table_manners-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s03_dining_table_manners-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s03_dining_table_manners-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s03_dining_table_manners-600.webp"
      }
    ]
  },
  "/img/scenes/s04_lounge_reading": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s04_lounge_reading-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s04_lounge_reading-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s04_lounge_reading-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s04_lounge_reading-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s04_lounge_reading-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s04_lounge_reading-600.webp"
      }
    ]
  },
  "/img/scenes/s05_lounge_fireplace_rose": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s05_lounge_fireplace_rose-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s05_lounge_fireplace_rose-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s05_lounge_fireplace_rose-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s05_lounge_fireplace_rose-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s05_lounge_fireplace_rose-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s05_lounge_fireplace_rose-600.webp"
      }
    ]
  },
  "/img/scenes/s06_lounge_headcare": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s06_lounge_headcare-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s06_lounge_headcare-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s06_lounge_headcare-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s06_lounge_headcare-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s06_lounge_headcare-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s06_lounge_headcare-600.webp"
      }
    ]
  },
  "/img/scenes/s07_bedroom_rest": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/s07_bedroom_rest-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/s07_bedroom_rest-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/s07_bedroom_rest-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/s07_bedroom_rest-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/s07_bedroom_rest-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/s07_bedroom_rest-600.webp"
      }
    ]
  },
  "/img/scenes/s08_bedroom_morning_tea": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/s08_bedroom_morning_tea-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/s08_bedroom_morning_tea-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/s08_bedroom_morning_tea-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/s08_bedroom_morning_tea-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/s08_bedroom_morning_tea-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/s08_bedroom_morning_tea-600.webp"
      }
    ]
  },
  "/img/scenes/s09_hall_gramophone": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s09_hall_gramophone-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s09_hall_gramophone-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s09_hall_gramophone-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s09_hall_gramophone-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s09_hall_gramophone-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s09_hall_gramophone-600.webp"
      }
    ]
  },
  "/img/scenes/s10_door_welcome": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s10_door_welcome-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s10_door_welcome-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s10_door_welcome-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s10_door_welcome-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s10_door_welcome-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s10_door_welcome-600.webp"
      }
    ]
  },
  "/img/scenes/s11_door_farewell": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s11_door_farewell-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s11_door_farewell-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s11_door_farewell-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s11_door_farewell-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s11_door_farewell-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s11_door_farewell-600.webp"
      }
    ]
  },
  "/img/scenes/s12_cabinet_choose_cup": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/s12_cabinet_choose_cup-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/s12_cabinet_choose_cup-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/s12_cabinet_choose_cup-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/s12_cabinet_choose_cup-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/s12_cabinet_choose_cup-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/s12_cabinet_choose_cup-600.webp"
      }
    ]
  },
  "/img/scenes/s13_tea_hands_receive": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s13_tea_hands_receive-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s13_tea_hands_receive-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s13_tea_hands_receive-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s13_tea_hands_receive-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s13_tea_hands_receive-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s13_tea_hands_receive-600.webp"
      }
    ]
  },
  "/img/scenes/s14_cup_hands_gift": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s14_cup_hands_gift-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s14_cup_hands_gift-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s14_cup_hands_gift-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s14_cup_hands_gift-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s14_cup_hands_gift-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s14_cup_hands_gift-600.webp"
      }
    ]
  },
  "/img/scenes/s15_watch_gift": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/s15_watch_gift-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/s15_watch_gift-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/s15_watch_gift-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/s15_watch_gift-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/s15_watch_gift-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/s15_watch_gift-600.webp"
      }
    ]
  },
  "/img/scenes/s16_footman_dressing": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s16_footman_dressing-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s16_footman_dressing-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s16_footman_dressing-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s16_footman_dressing-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s16_footman_dressing-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s16_footman_dressing-600.webp"
      }
    ]
  },
  "/img/scenes/s17_footman_tea_practice": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/s17_footman_tea_practice-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/s17_footman_tea_practice-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/s17_footman_tea_practice-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/s17_footman_tea_practice-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/s17_footman_tea_practice-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/s17_footman_tea_practice-600.webp"
      }
    ]
  },
  "/img/scenes/s18_footman_bow": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s18_footman_bow-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s18_footman_bow-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s18_footman_bow-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s18_footman_bow-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s18_footman_bow-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s18_footman_bow-600.webp"
      }
    ]
  },
  "/img/scenes/s19_studio_portrait": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/s19_studio_portrait-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/s19_studio_portrait-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/s19_studio_portrait-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/s19_studio_portrait-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/s19_studio_portrait-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/s19_studio_portrait-600.webp"
      }
    ]
  },
  "/img/scenes/s20_studio_bridal": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s20_studio_bridal-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s20_studio_bridal-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s20_studio_bridal-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s20_studio_bridal-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s20_studio_bridal-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s20_studio_bridal-600.webp"
      }
    ]
  },
  "/img/scenes/s21_studio_friends": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s21_studio_friends-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s21_studio_friends-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s21_studio_friends-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s21_studio_friends-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s21_studio_friends-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s21_studio_friends-600.webp"
      }
    ]
  },
  "/img/scenes/s22_buddy_walk": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s22_buddy_walk-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s22_buddy_walk-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s22_buddy_walk-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s22_buddy_walk-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s22_buddy_walk-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s22_buddy_walk-600.webp"
      }
    ]
  },
  "/img/scenes/s23_night_candle": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/s23_night_candle-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/s23_night_candle-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/s23_night_candle-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/s23_night_candle-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/s23_night_candle-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/s23_night_candle-600.webp"
      }
    ]
  },
  "/img/scenes/s24_hero_wide": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s24_hero_wide-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/s24_hero_wide-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s24_hero_wide-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/s24_hero_wide-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s24_hero_wide-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/s24_hero_wide-600.webp"
      }
    ]
  },
  "/img/scenes/a01_study_desk": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/a01_study_desk-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/a01_study_desk-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/a01_study_desk-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/a01_study_desk-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a01_study_desk-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a01_study_desk-600.webp"
      }
    ]
  },
  "/img/scenes/a02_study_shelf": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/a02_study_shelf-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/a02_study_shelf-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/a02_study_shelf-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/a02_study_shelf-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a02_study_shelf-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a02_study_shelf-600.webp"
      }
    ]
  },
  "/img/scenes/a04_bedside_candelabra": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/a04_bedside_candelabra-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/a04_bedside_candelabra-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/a04_bedside_candelabra-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/a04_bedside_candelabra-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/a04_bedside_candelabra-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/a04_bedside_candelabra-600.webp"
      }
    ]
  },
  "/img/scenes/a05_hall_wide": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/a05_hall_wide-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/a05_hall_wide-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/a05_hall_wide-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/a05_hall_wide-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a05_hall_wide-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a05_hall_wide-600.webp"
      }
    ]
  },
  "/img/scenes/a06_cabinet": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/a06_cabinet-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/a06_cabinet-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/a06_cabinet-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/a06_cabinet-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a06_cabinet-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a06_cabinet-600.webp"
      }
    ]
  },
  "/img/scenes/a07_wardrobe": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/a07_wardrobe-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/a07_wardrobe-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/a07_wardrobe-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/a07_wardrobe-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/a07_wardrobe-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/a07_wardrobe-600.webp"
      }
    ]
  },
  "/img/scenes/a08_plates_flatlay": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/a08_plates_flatlay-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/a08_plates_flatlay-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/a08_plates_flatlay-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/a08_plates_flatlay-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a08_plates_flatlay-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a08_plates_flatlay-600.webp"
      }
    ]
  },
  "/img/scenes/b01_study_letter": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b01_study_letter-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b01_study_letter-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b01_study_letter-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b01_study_letter-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b01_study_letter-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b01_study_letter-600.webp"
      }
    ]
  },
  "/img/scenes/b02_study_reading": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b02_study_reading-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b02_study_reading-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b02_study_reading-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b02_study_reading-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b02_study_reading-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b02_study_reading-600.webp"
      }
    ]
  },
  "/img/scenes/b03_study_globe": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b03_study_globe-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b03_study_globe-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b03_study_globe-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b03_study_globe-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b03_study_globe-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b03_study_globe-600.webp"
      }
    ]
  },
  "/img/scenes/b04_study_typewriter": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b04_study_typewriter-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b04_study_typewriter-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b04_study_typewriter-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b04_study_typewriter-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b04_study_typewriter-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b04_study_typewriter-600.webp"
      }
    ]
  },
  "/img/scenes/b06_bedside_goodnight_tea": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/b06_bedside_goodnight_tea-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/b06_bedside_goodnight_tea-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/b06_bedside_goodnight_tea-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/b06_bedside_goodnight_tea-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/b06_bedside_goodnight_tea-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/b06_bedside_goodnight_tea-600.webp"
      }
    ]
  },
  "/img/scenes/b07_wardrobe_choose_coat": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/b07_wardrobe_choose_coat-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/b07_wardrobe_choose_coat-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/b07_wardrobe_choose_coat-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/b07_wardrobe_choose_coat-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/b07_wardrobe_choose_coat-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/b07_wardrobe_choose_coat-600.webp"
      }
    ]
  },
  "/img/scenes/b08_wardrobe_top_hat": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/b08_wardrobe_top_hat-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/b08_wardrobe_top_hat-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/b08_wardrobe_top_hat-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/b08_wardrobe_top_hat-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/b08_wardrobe_top_hat-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/b08_wardrobe_top_hat-600.webp"
      }
    ]
  },
  "/img/scenes/b09_glove_fitting": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b09_glove_fitting-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b09_glove_fitting-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b09_glove_fitting-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b09_glove_fitting-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b09_glove_fitting-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b09_glove_fitting-600.webp"
      }
    ]
  },
  "/img/scenes/b10_cabinet_tea_choice": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b10_cabinet_tea_choice-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b10_cabinet_tea_choice-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b10_cabinet_tea_choice-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b10_cabinet_tea_choice-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b10_cabinet_tea_choice-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b10_cabinet_tea_choice-600.webp"
      }
    ]
  },
  "/img/scenes/b11_hall_arrival": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b11_hall_arrival-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b11_hall_arrival-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b11_hall_arrival-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b11_hall_arrival-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b11_hall_arrival-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b11_hall_arrival-600.webp"
      }
    ]
  },
  "/img/scenes/b12_lounge_two_ladies": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b12_lounge_two_ladies-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/b12_lounge_two_ladies-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b12_lounge_two_ladies-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/b12_lounge_two_ladies-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b12_lounge_two_ladies-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/b12_lounge_two_ladies-600.webp"
      }
    ]
  },
  "/img/scenes/cast_female_butler_front": {
    "width": 1600,
    "height": 2401,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2401,
        "src": "/img/scenes/cast_female_butler_front-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2401,
        "src": "/img/scenes/cast_female_butler_front-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/cast_female_butler_front-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/cast_female_butler_front-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/cast_female_butler_front-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/cast_female_butler_front-600.webp"
      }
    ]
  },
  "/img/scenes/cast_female_butler_profile": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/cast_female_butler_profile-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/cast_female_butler_profile-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/cast_female_butler_profile-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/cast_female_butler_profile-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/cast_female_butler_profile-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/cast_female_butler_profile-600.webp"
      }
    ]
  },
  "/img/scenes/f01_hero_female_butler_tea": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f01_hero_female_butler_tea-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f01_hero_female_butler_tea-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f01_hero_female_butler_tea-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f01_hero_female_butler_tea-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f01_hero_female_butler_tea-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f01_hero_female_butler_tea-600.webp"
      }
    ]
  },
  "/img/scenes/f02_door_welcome_female": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f02_door_welcome_female-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f02_door_welcome_female-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f02_door_welcome_female-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f02_door_welcome_female-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f02_door_welcome_female-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f02_door_welcome_female-600.webp"
      }
    ]
  },
  "/img/scenes/f03_lounge_blanket": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f03_lounge_blanket-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f03_lounge_blanket-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f03_lounge_blanket-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f03_lounge_blanket-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f03_lounge_blanket-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f03_lounge_blanket-600.webp"
      }
    ]
  },
  "/img/scenes/f04_afternoon_tea_stand": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f04_afternoon_tea_stand-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f04_afternoon_tea_stand-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f04_afternoon_tea_stand-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f04_afternoon_tea_stand-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f04_afternoon_tea_stand-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f04_afternoon_tea_stand-600.webp"
      }
    ]
  },
  "/img/scenes/f05_headcare_female": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f05_headcare_female-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f05_headcare_female-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f05_headcare_female-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f05_headcare_female-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f05_headcare_female-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f05_headcare_female-600.webp"
      }
    ]
  },
  "/img/scenes/f06_study_letter_female": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f06_study_letter_female-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f06_study_letter_female-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f06_study_letter_female-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f06_study_letter_female-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f06_study_letter_female-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f06_study_letter_female-600.webp"
      }
    ]
  },
  "/img/scenes/f07_cabinet_cups_female": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f07_cabinet_cups_female-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f07_cabinet_cups_female-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f07_cabinet_cups_female-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f07_cabinet_cups_female-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f07_cabinet_cups_female-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f07_cabinet_cups_female-600.webp"
      }
    ]
  },
  "/img/scenes/f08_tea_hands_female": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f08_tea_hands_female-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f08_tea_hands_female-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f08_tea_hands_female-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f08_tea_hands_female-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f08_tea_hands_female-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f08_tea_hands_female-600.webp"
      }
    ]
  },
  "/img/scenes/f09_buddy_walk_female": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f09_buddy_walk_female-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f09_buddy_walk_female-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f09_buddy_walk_female-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f09_buddy_walk_female-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f09_buddy_walk_female-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f09_buddy_walk_female-600.webp"
      }
    ]
  },
  "/img/scenes/f10_two_butlers_bow": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f10_two_butlers_bow-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f10_two_butlers_bow-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f10_two_butlers_bow-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f10_two_butlers_bow-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f10_two_butlers_bow-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f10_two_butlers_bow-600.webp"
      }
    ]
  },
  "/img/scenes/f11_footman_dressing_female_guide": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f11_footman_dressing_female_guide-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/f11_footman_dressing_female_guide-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f11_footman_dressing_female_guide-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/f11_footman_dressing_female_guide-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f11_footman_dressing_female_guide-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/f11_footman_dressing_female_guide-600.webp"
      }
    ]
  },
  "/img/scenes/f12_portrait_female_butler_roses": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/f12_portrait_female_butler_roses-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/f12_portrait_female_butler_roses-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/f12_portrait_female_butler_roses-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/f12_portrait_female_butler_roses-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/f12_portrait_female_butler_roses-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/f12_portrait_female_butler_roses-600.webp"
      }
    ]
  },
  "/img/scenes/01_1786972970388": {
    "width": 1600,
    "height": 2399,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/01_1786972970388-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/01_1786972970388-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/01_1786972970388-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/01_1786972970388-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/01_1786972970388-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/01_1786972970388-600.webp"
      }
    ]
  },
  "/img/scenes/02_1786973020497": {
    "width": 1600,
    "height": 2399,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/02_1786973020497-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/02_1786973020497-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/02_1786973020497-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/02_1786973020497-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/02_1786973020497-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/02_1786973020497-600.webp"
      }
    ]
  },
  "/img/scenes/03_1786973058864": {
    "width": 1600,
    "height": 2399,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/03_1786973058864-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/03_1786973058864-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/03_1786973058864-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/03_1786973058864-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/03_1786973058864-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/03_1786973058864-600.webp"
      }
    ]
  },
  "/img/scenes/04_1786973168324": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/04_1786973168324-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/04_1786973168324-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/04_1786973168324-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/04_1786973168324-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/04_1786973168324-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/04_1786973168324-600.webp"
      }
    ]
  },
  "/img/scenes/05_1786973179689": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/05_1786973179689-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/05_1786973179689-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/05_1786973179689-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/05_1786973179689-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/05_1786973179689-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/05_1786973179689-600.webp"
      }
    ]
  },
  "/img/scenes/06_1786973212294": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/06_1786973212294-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/06_1786973212294-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/06_1786973212294-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/06_1786973212294-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/06_1786973212294-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/06_1786973212294-600.webp"
      }
    ]
  },
  "/img/scenes/07_1786973427538": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/07_1786973427538-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/07_1786973427538-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/07_1786973427538-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/07_1786973427538-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/07_1786973427538-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/07_1786973427538-600.webp"
      }
    ]
  },
  "/img/scenes/08_1786974302937": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/08_1786974302937-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/08_1786974302937-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/08_1786974302937-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/08_1786974302937-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/08_1786974302937-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/08_1786974302937-600.webp"
      }
    ]
  },
  "/img/scenes/09_1786974335142": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/09_1786974335142-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/09_1786974335142-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/09_1786974335142-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/09_1786974335142-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/09_1786974335142-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/09_1786974335142-600.webp"
      }
    ]
  },
  "/img/scenes/10_1786974337179": {
    "width": 1600,
    "height": 2399,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/10_1786974337179-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/10_1786974337179-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/10_1786974337179-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/10_1786974337179-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/10_1786974337179-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/10_1786974337179-600.webp"
      }
    ]
  },
  "/img/scenes/11_1786974370556": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/11_1786974370556-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/11_1786974370556-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/11_1786974370556-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/11_1786974370556-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/11_1786974370556-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/11_1786974370556-600.webp"
      }
    ]
  },
  "/img/scenes/12_1786974381743": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/12_1786974381743-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/12_1786974381743-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/12_1786974381743-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/12_1786974381743-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/12_1786974381743-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/12_1786974381743-600.webp"
      }
    ]
  },
  "/img/scenes/13_1786974385895": {
    "width": 1600,
    "height": 2399,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/13_1786974385895-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/13_1786974385895-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/13_1786974385895-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/13_1786974385895-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/13_1786974385895-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/13_1786974385895-600.webp"
      }
    ]
  },
  "/img/scenes/14_MEITU_20260817_223349622": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/14_MEITU_20260817_223349622-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/14_MEITU_20260817_223349622-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/14_MEITU_20260817_223349622-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/14_MEITU_20260817_223349622-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/14_MEITU_20260817_223349622-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/14_MEITU_20260817_223349622-600.webp"
      }
    ]
  },
  "/img/scenes/15_MEITU_20260817_223503840": {
    "width": 1600,
    "height": 2399,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/15_MEITU_20260817_223503840-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/15_MEITU_20260817_223503840-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/15_MEITU_20260817_223503840-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/15_MEITU_20260817_223503840-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/15_MEITU_20260817_223503840-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/15_MEITU_20260817_223503840-600.webp"
      }
    ]
  },
  "/img/scenes/16_MEITU_20260817_223611062": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/16_MEITU_20260817_223611062-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/16_MEITU_20260817_223611062-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/16_MEITU_20260817_223611062-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/16_MEITU_20260817_223611062-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/16_MEITU_20260817_223611062-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/16_MEITU_20260817_223611062-600.webp"
      }
    ]
  },
  "/img/scenes/17_MEITU_20260817_223704244": {
    "width": 1600,
    "height": 2399,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/17_MEITU_20260817_223704244-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/17_MEITU_20260817_223704244-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/17_MEITU_20260817_223704244-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/17_MEITU_20260817_223704244-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/17_MEITU_20260817_223704244-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/17_MEITU_20260817_223704244-600.webp"
      }
    ]
  },
  "/img/scenes/18_MEITU_20260817_223802434": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/18_MEITU_20260817_223802434-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/18_MEITU_20260817_223802434-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/18_MEITU_20260817_223802434-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/18_MEITU_20260817_223802434-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/18_MEITU_20260817_223802434-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/18_MEITU_20260817_223802434-600.webp"
      }
    ]
  },
  "/img/scenes/19_MEITU_20260817_223957976": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/19_MEITU_20260817_223957976-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/19_MEITU_20260817_223957976-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/19_MEITU_20260817_223957976-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/19_MEITU_20260817_223957976-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/19_MEITU_20260817_223957976-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/19_MEITU_20260817_223957976-600.webp"
      }
    ]
  },
  "/img/scenes/a01": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a01-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a01-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a01-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a01-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a01-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a01-600.webp"
      }
    ]
  },
  "/img/scenes/a02": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a02-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a02-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a02-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a02-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a02-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a02-600.webp"
      }
    ]
  },
  "/img/scenes/a03": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a03-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a03-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a03-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a03-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a03-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a03-600.webp"
      }
    ]
  },
  "/img/scenes/a04": {
    "width": 1600,
    "height": 2402,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2402,
        "src": "/img/scenes/a04-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2402,
        "src": "/img/scenes/a04-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1501,
        "src": "/img/scenes/a04-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1501,
        "src": "/img/scenes/a04-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 901,
        "src": "/img/scenes/a04-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 901,
        "src": "/img/scenes/a04-600.webp"
      }
    ]
  },
  "/img/scenes/a05": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a05-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a05-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a05-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a05-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a05-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a05-600.webp"
      }
    ]
  },
  "/img/scenes/a06": {
    "width": 1600,
    "height": 2402,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2402,
        "src": "/img/scenes/a06-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2402,
        "src": "/img/scenes/a06-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1501,
        "src": "/img/scenes/a06-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1501,
        "src": "/img/scenes/a06-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 901,
        "src": "/img/scenes/a06-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 901,
        "src": "/img/scenes/a06-600.webp"
      }
    ]
  },
  "/img/scenes/a07": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a07-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a07-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a07-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a07-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a07-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a07-600.webp"
      }
    ]
  },
  "/img/scenes/a08": {
    "width": 1600,
    "height": 2402,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2402,
        "src": "/img/scenes/a08-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2402,
        "src": "/img/scenes/a08-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1501,
        "src": "/img/scenes/a08-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1501,
        "src": "/img/scenes/a08-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 901,
        "src": "/img/scenes/a08-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 901,
        "src": "/img/scenes/a08-600.webp"
      }
    ]
  },
  "/img/scenes/a09": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a09-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a09-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a09-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a09-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a09-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a09-600.webp"
      }
    ]
  },
  "/img/scenes/a10": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a10-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a10-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a10-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a10-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a10-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a10-600.webp"
      }
    ]
  },
  "/img/scenes/a11": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a11-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/a11-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a11-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/a11-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a11-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/a11-600.webp"
      }
    ]
  },
  "/img/scenes/b07": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/b07-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/b07-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/b07-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/b07-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/b07-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/b07-600.webp"
      }
    ]
  },
  "/img/scenes/b08": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/b08-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/b08-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/b08-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/b08-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/b08-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/b08-600.webp"
      }
    ]
  },
  "/img/scenes/b09": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/b09-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/b09-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/b09-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/b09-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/b09-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/b09-600.webp"
      }
    ]
  },
  "/img/deco/petals_scatter": {
    "width": 1024,
    "height": 512,
    "variants": [
      {
        "format": "png",
        "width": 1024,
        "height": 512,
        "src": "/img/deco/petals_scatter-1024.png"
      },
      {
        "format": "webp",
        "width": 1024,
        "height": 512,
        "src": "/img/deco/petals_scatter-1024.webp"
      },
      {
        "format": "png",
        "width": 512,
        "height": 256,
        "src": "/img/deco/petals_scatter-512.png"
      },
      {
        "format": "webp",
        "width": 512,
        "height": 256,
        "src": "/img/deco/petals_scatter-512.webp"
      }
    ]
  },
  "/img/deco/rose_bouquet_side": {
    "width": 1024,
    "height": 1536,
    "variants": [
      {
        "format": "png",
        "width": 1024,
        "height": 1536,
        "src": "/img/deco/rose_bouquet_side-1024.png"
      },
      {
        "format": "webp",
        "width": 1024,
        "height": 1536,
        "src": "/img/deco/rose_bouquet_side-1024.webp"
      },
      {
        "format": "png",
        "width": 512,
        "height": 768,
        "src": "/img/deco/rose_bouquet_side-512.png"
      },
      {
        "format": "webp",
        "width": 512,
        "height": 768,
        "src": "/img/deco/rose_bouquet_side-512.webp"
      }
    ]
  },
  "/img/deco/rose_bud_mark": {
    "width": 1024,
    "height": 1024,
    "variants": [
      {
        "format": "png",
        "width": 1024,
        "height": 1024,
        "src": "/img/deco/rose_bud_mark-1024.png"
      },
      {
        "format": "webp",
        "width": 1024,
        "height": 1024,
        "src": "/img/deco/rose_bud_mark-1024.webp"
      },
      {
        "format": "png",
        "width": 512,
        "height": 512,
        "src": "/img/deco/rose_bud_mark-512.png"
      },
      {
        "format": "webp",
        "width": 512,
        "height": 512,
        "src": "/img/deco/rose_bud_mark-512.webp"
      }
    ]
  },
  "/img/deco/rose_bud_mark_rose": {
    "width": 1024,
    "height": 1024,
    "variants": [
      {
        "format": "png",
        "width": 1024,
        "height": 1024,
        "src": "/img/deco/rose_bud_mark_rose-1024.png"
      },
      {
        "format": "webp",
        "width": 1024,
        "height": 1024,
        "src": "/img/deco/rose_bud_mark_rose-1024.webp"
      },
      {
        "format": "png",
        "width": 512,
        "height": 512,
        "src": "/img/deco/rose_bud_mark_rose-512.png"
      },
      {
        "format": "webp",
        "width": 512,
        "height": 512,
        "src": "/img/deco/rose_bud_mark_rose-512.webp"
      }
    ]
  },
  "/img/deco/rose_bud_mark_white": {
    "width": 1024,
    "height": 1024,
    "variants": [
      {
        "format": "png",
        "width": 1024,
        "height": 1024,
        "src": "/img/deco/rose_bud_mark_white-1024.png"
      },
      {
        "format": "webp",
        "width": 1024,
        "height": 1024,
        "src": "/img/deco/rose_bud_mark_white-1024.webp"
      },
      {
        "format": "png",
        "width": 512,
        "height": 512,
        "src": "/img/deco/rose_bud_mark_white-512.png"
      },
      {
        "format": "webp",
        "width": 512,
        "height": 512,
        "src": "/img/deco/rose_bud_mark_white-512.webp"
      }
    ]
  },
  "/img/deco/rose_corner_br": {
    "width": 1024,
    "height": 1024,
    "variants": [
      {
        "format": "png",
        "width": 1024,
        "height": 1024,
        "src": "/img/deco/rose_corner_br-1024.png"
      },
      {
        "format": "webp",
        "width": 1024,
        "height": 1024,
        "src": "/img/deco/rose_corner_br-1024.webp"
      },
      {
        "format": "png",
        "width": 512,
        "height": 512,
        "src": "/img/deco/rose_corner_br-512.png"
      },
      {
        "format": "webp",
        "width": 512,
        "height": 512,
        "src": "/img/deco/rose_corner_br-512.webp"
      }
    ]
  },
  "/img/deco/rose_corner_tl": {
    "width": 1024,
    "height": 1024,
    "variants": [
      {
        "format": "png",
        "width": 1024,
        "height": 1024,
        "src": "/img/deco/rose_corner_tl-1024.png"
      },
      {
        "format": "webp",
        "width": 1024,
        "height": 1024,
        "src": "/img/deco/rose_corner_tl-1024.webp"
      },
      {
        "format": "png",
        "width": 512,
        "height": 512,
        "src": "/img/deco/rose_corner_tl-512.png"
      },
      {
        "format": "webp",
        "width": 512,
        "height": 512,
        "src": "/img/deco/rose_corner_tl-512.webp"
      }
    ]
  },
  "/img/deco/rose_frame_oval": {
    "width": 1024,
    "height": 1280,
    "variants": [
      {
        "format": "png",
        "width": 1024,
        "height": 1280,
        "src": "/img/deco/rose_frame_oval-1024.png"
      },
      {
        "format": "webp",
        "width": 1024,
        "height": 1280,
        "src": "/img/deco/rose_frame_oval-1024.webp"
      },
      {
        "format": "png",
        "width": 512,
        "height": 640,
        "src": "/img/deco/rose_frame_oval-512.png"
      },
      {
        "format": "webp",
        "width": 512,
        "height": 640,
        "src": "/img/deco/rose_frame_oval-512.webp"
      }
    ]
  },
  "/img/deco/rose_line_divider": {
    "width": 1024,
    "height": 128,
    "variants": [
      {
        "format": "png",
        "width": 1024,
        "height": 128,
        "src": "/img/deco/rose_line_divider-1024.png"
      },
      {
        "format": "webp",
        "width": 1024,
        "height": 128,
        "src": "/img/deco/rose_line_divider-1024.webp"
      },
      {
        "format": "png",
        "width": 512,
        "height": 64,
        "src": "/img/deco/rose_line_divider-512.png"
      },
      {
        "format": "webp",
        "width": 512,
        "height": 64,
        "src": "/img/deco/rose_line_divider-512.webp"
      }
    ]
  },
  "/img/deco/rose_single_lying": {
    "width": 1024,
    "height": 683,
    "variants": [
      {
        "format": "png",
        "width": 1024,
        "height": 683,
        "src": "/img/deco/rose_single_lying-1024.png"
      },
      {
        "format": "webp",
        "width": 1024,
        "height": 683,
        "src": "/img/deco/rose_single_lying-1024.webp"
      },
      {
        "format": "png",
        "width": 512,
        "height": 341,
        "src": "/img/deco/rose_single_lying-512.png"
      },
      {
        "format": "webp",
        "width": 512,
        "height": 341,
        "src": "/img/deco/rose_single_lying-512.webp"
      }
    ]
  },
  "/img/deco/rose_watermark_line": {
    "width": 1024,
    "height": 1024,
    "variants": [
      {
        "format": "png",
        "width": 1024,
        "height": 1024,
        "src": "/img/deco/rose_watermark_line-1024.png"
      },
      {
        "format": "webp",
        "width": 1024,
        "height": 1024,
        "src": "/img/deco/rose_watermark_line-1024.webp"
      },
      {
        "format": "png",
        "width": 512,
        "height": 512,
        "src": "/img/deco/rose_watermark_line-512.png"
      },
      {
        "format": "webp",
        "width": 512,
        "height": 512,
        "src": "/img/deco/rose_watermark_line-512.webp"
      }
    ]
  },
  "/img/scenes/cast_f20": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/cast_f20-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/cast_f20-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/cast_f20-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/cast_f20-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/cast_f20-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/cast_f20-600.webp"
      }
    ]
  },
  "/img/scenes/cast_f40": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/cast_f40-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/cast_f40-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/cast_f40-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/cast_f40-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/cast_f40-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/cast_f40-600.webp"
      }
    ]
  },
  "/img/scenes/cast_f60": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/cast_f60-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/cast_f60-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/cast_f60-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/cast_f60-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/cast_f60-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/cast_f60-600.webp"
      }
    ]
  },
  "/img/scenes/cast_m20": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/cast_m20-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/cast_m20-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/cast_m20-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/cast_m20-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/cast_m20-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/cast_m20-600.webp"
      }
    ]
  },
  "/img/scenes/cast_m40": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/cast_m40-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/cast_m40-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/cast_m40-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/cast_m40-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/cast_m40-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/cast_m40-600.webp"
      }
    ]
  },
  "/img/scenes/cast_m60": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/cast_m60-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/cast_m60-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/cast_m60-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/cast_m60-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/cast_m60-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/cast_m60-600.webp"
      }
    ]
  },
  "/img/scenes/guest_20s": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/guest_20s-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/guest_20s-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/guest_20s-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/guest_20s-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/guest_20s-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/guest_20s-600.webp"
      }
    ]
  },
  "/img/scenes/guest_30s": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/guest_30s-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/guest_30s-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/guest_30s-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/guest_30s-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/guest_30s-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/guest_30s-600.webp"
      }
    ]
  },
  "/img/scenes/guest_50s": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/guest_50s-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/guest_50s-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/guest_50s-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/guest_50s-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/guest_50s-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/guest_50s-600.webp"
      }
    ]
  },
  "/img/scenes/guest_70s": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/guest_70s-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/guest_70s-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/guest_70s-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/guest_70s-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/guest_70s-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/guest_70s-600.webp"
      }
    ]
  },
  "/img/scenes/b07_clean": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/b07_clean-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/b07_clean-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/b07_clean-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/b07_clean-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/b07_clean-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/b07_clean-600.webp"
      }
    ]
  },
  "/img/scenes/b08_clean": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/b08_clean-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/b08_clean-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/b08_clean-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/b08_clean-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/b08_clean-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/b08_clean-600.webp"
      }
    ]
  },
  "/img/scenes/b09_clean": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/b09_clean-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/b09_clean-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/b09_clean-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/b09_clean-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/b09_clean-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/b09_clean-600.webp"
      }
    ]
  },
  "/img/scenes/drive01_door_open": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/drive01_door_open-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/drive01_door_open-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/drive01_door_open-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/drive01_door_open-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/drive01_door_open-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/drive01_door_open-600.webp"
      }
    ]
  },
  "/img/scenes/drive02_rear_seat": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/drive02_rear_seat-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/drive02_rear_seat-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/drive02_rear_seat-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/drive02_rear_seat-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/drive02_rear_seat-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/drive02_rear_seat-600.webp"
      }
    ]
  },
  "/img/scenes/drive03_bridge_view": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/drive03_bridge_view-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/drive03_bridge_view-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/drive03_bridge_view-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/drive03_bridge_view-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/drive03_bridge_view-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/drive03_bridge_view-600.webp"
      }
    ]
  },
  "/img/scenes/drive04_return": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/drive04_return-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/drive04_return-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/drive04_return-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/drive04_return-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/drive04_return-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/drive04_return-600.webp"
      }
    ]
  },
  "/img/scenes/drive05_car_only": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/drive05_car_only-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/drive05_car_only-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/drive05_car_only-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/drive05_car_only-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/drive05_car_only-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/drive05_car_only-600.webp"
      }
    ]
  },
  "/img/scenes/drive06_shopping": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/drive06_shopping-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/drive06_shopping-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/drive06_shopping-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/drive06_shopping-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/drive06_shopping-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/drive06_shopping-600.webp"
      }
    ]
  },
  "/img/scenes/th01_theater_screen_room": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/th01_theater_screen_room-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/th01_theater_screen_room-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/th01_theater_screen_room-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/th01_theater_screen_room-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/th01_theater_screen_room-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/th01_theater_screen_room-600.webp"
      }
    ]
  },
  "/img/scenes/th02_theater_screen_guest": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/th02_theater_screen_guest-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/th02_theater_screen_guest-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/th02_theater_screen_guest-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/th02_theater_screen_guest-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/th02_theater_screen_guest-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/th02_theater_screen_guest-600.webp"
      }
    ]
  },
  "/img/scenes/th03_theater_screen_daylight": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/th03_theater_screen_daylight-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/th03_theater_screen_daylight-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/th03_theater_screen_daylight-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/th03_theater_screen_daylight-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/th03_theater_screen_daylight-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/th03_theater_screen_daylight-600.webp"
      }
    ]
  },
  "/img/scenes/sc10_studio_shoot_wide": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sc10_studio_shoot_wide-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sc10_studio_shoot_wide-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sc10_studio_shoot_wide-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sc10_studio_shoot_wide-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sc10_studio_shoot_wide-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sc10_studio_shoot_wide-600.webp"
      }
    ]
  },
  "/img/scenes/sc11_intl_meeting_dining": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sc11_intl_meeting_dining-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sc11_intl_meeting_dining-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sc11_intl_meeting_dining-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sc11_intl_meeting_dining-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sc11_intl_meeting_dining-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sc11_intl_meeting_dining-600.webp"
      }
    ]
  },
  "/img/scenes/sc12_intl_meeting_study": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sc12_intl_meeting_study-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sc12_intl_meeting_study-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sc12_intl_meeting_study-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sc12_intl_meeting_study-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sc12_intl_meeting_study-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sc12_intl_meeting_study-600.webp"
      }
    ]
  },
  "/img/scenes/sc13_studio_wardrobe_fitting": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sc13_studio_wardrobe_fitting-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sc13_studio_wardrobe_fitting-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sc13_studio_wardrobe_fitting-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sc13_studio_wardrobe_fitting-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sc13_studio_wardrobe_fitting-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sc13_studio_wardrobe_fitting-600.webp"
      }
    ]
  },
  "/img/scenes/sc14_studio_hero_wide": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sc14_studio_hero_wide-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sc14_studio_hero_wide-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sc14_studio_hero_wide-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sc14_studio_hero_wide-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sc14_studio_hero_wide-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sc14_studio_hero_wide-600.webp"
      }
    ]
  },
  "/img/scenes/eq_screen_awol_mwf220": {
    "width": 1600,
    "height": 1431,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1431,
        "src": "/img/scenes/eq_screen_awol_mwf220-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1431,
        "src": "/img/scenes/eq_screen_awol_mwf220-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 895,
        "src": "/img/scenes/eq_screen_awol_mwf220-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 895,
        "src": "/img/scenes/eq_screen_awol_mwf220-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 537,
        "src": "/img/scenes/eq_screen_awol_mwf220-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 537,
        "src": "/img/scenes/eq_screen_awol_mwf220-600.webp"
      }
    ]
  },
  "/img/scenes/eq_projector_valerion_visionmaster_max": {
    "width": 1600,
    "height": 1193,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1193,
        "src": "/img/scenes/eq_projector_valerion_visionmaster_max-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1193,
        "src": "/img/scenes/eq_projector_valerion_visionmaster_max-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 746,
        "src": "/img/scenes/eq_projector_valerion_visionmaster_max-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 746,
        "src": "/img/scenes/eq_projector_valerion_visionmaster_max-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 448,
        "src": "/img/scenes/eq_projector_valerion_visionmaster_max-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 448,
        "src": "/img/scenes/eq_projector_valerion_visionmaster_max-600.webp"
      }
    ]
  },
  "/img/scenes/eq_soundbar_jbl_bar1300m2": {
    "width": 1600,
    "height": 826,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 826,
        "src": "/img/scenes/eq_soundbar_jbl_bar1300m2-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 826,
        "src": "/img/scenes/eq_soundbar_jbl_bar1300m2-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 516,
        "src": "/img/scenes/eq_soundbar_jbl_bar1300m2-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 516,
        "src": "/img/scenes/eq_soundbar_jbl_bar1300m2-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 310,
        "src": "/img/scenes/eq_soundbar_jbl_bar1300m2-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 310,
        "src": "/img/scenes/eq_soundbar_jbl_bar1300m2-600.webp"
      }
    ]
  },
  "/img/scenes/col_bradley-yew-table": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_bradley-yew-table-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_bradley-yew-table-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_bradley-yew-table-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_bradley-yew-table-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_bradley-yew-table-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_bradley-yew-table-600.webp"
      }
    ]
  },
  "/img/scenes/col_maria-theresa-chandelier": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_maria-theresa-chandelier-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_maria-theresa-chandelier-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_maria-theresa-chandelier-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_maria-theresa-chandelier-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_maria-theresa-chandelier-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_maria-theresa-chandelier-600.webp"
      }
    ]
  },
  "/img/scenes/col_table-candelabra-silver-bell": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/col_table-candelabra-silver-bell-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/col_table-candelabra-silver-bell-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/col_table-candelabra-silver-bell-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/col_table-candelabra-silver-bell-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_table-candelabra-silver-bell-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_table-candelabra-silver-bell-600.webp"
      }
    ]
  },
  "/img/scenes/col_dining-chairs": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_dining-chairs-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_dining-chairs-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_dining-chairs-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_dining-chairs-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_dining-chairs-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_dining-chairs-600.webp"
      }
    ]
  },
  "/img/scenes/col_persian-carpet": {
    "width": 1600,
    "height": 1065,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1065,
        "src": "/img/scenes/col_persian-carpet-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1065,
        "src": "/img/scenes/col_persian-carpet-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_persian-carpet-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_persian-carpet-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 399,
        "src": "/img/scenes/col_persian-carpet-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 399,
        "src": "/img/scenes/col_persian-carpet-600.webp"
      }
    ]
  },
  "/img/scenes/col_twin-pedestal-desk": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_twin-pedestal-desk-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_twin-pedestal-desk-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_twin-pedestal-desk-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_twin-pedestal-desk-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_twin-pedestal-desk-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_twin-pedestal-desk-600.webp"
      }
    ]
  },
  "/img/scenes/col_captain-chair": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_captain-chair-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_captain-chair-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_captain-chair-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_captain-chair-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_captain-chair-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_captain-chair-600.webp"
      }
    ]
  },
  "/img/scenes/col_study-lighting": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_study-lighting-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_study-lighting-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_study-lighting-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_study-lighting-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_study-lighting-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_study-lighting-600.webp"
      }
    ]
  },
  "/img/scenes/col_knight-armor": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_knight-armor-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_knight-armor-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_knight-armor-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_knight-armor-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_knight-armor-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_knight-armor-600.webp"
      }
    ]
  },
  "/img/scenes/col_guest-corner": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_guest-corner-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_guest-corner-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_guest-corner-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_guest-corner-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_guest-corner-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_guest-corner-600.webp"
      }
    ]
  },
  "/img/scenes/col_fireplace-mantel": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_fireplace-mantel-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_fireplace-mantel-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_fireplace-mantel-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_fireplace-mantel-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_fireplace-mantel-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_fireplace-mantel-600.webp"
      }
    ]
  },
  "/img/scenes/col_gold-damask-wall": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/col_gold-damask-wall-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/col_gold-damask-wall-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/col_gold-damask-wall-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/col_gold-damask-wall-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_gold-damask-wall-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_gold-damask-wall-600.webp"
      }
    ]
  },
  "/img/scenes/col_joglar-6-chandelier": {
    "width": 1600,
    "height": 1065,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1065,
        "src": "/img/scenes/col_joglar-6-chandelier-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1065,
        "src": "/img/scenes/col_joglar-6-chandelier-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_joglar-6-chandelier-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_joglar-6-chandelier-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 399,
        "src": "/img/scenes/col_joglar-6-chandelier-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 399,
        "src": "/img/scenes/col_joglar-6-chandelier-600.webp"
      }
    ]
  },
  "/img/scenes/col_rococo-velvet-sofa": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_rococo-velvet-sofa-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_rococo-velvet-sofa-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_rococo-velvet-sofa-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_rococo-velvet-sofa-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_rococo-velvet-sofa-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_rococo-velvet-sofa-600.webp"
      }
    ]
  },
  "/img/scenes/col_theater-120-inch": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_theater-120-inch-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_theater-120-inch-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_theater-120-inch-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_theater-120-inch-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_theater-120-inch-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_theater-120-inch-600.webp"
      }
    ]
  },
  "/img/scenes/col_corbeille-bed": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_corbeille-bed-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_corbeille-bed-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_corbeille-bed-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_corbeille-bed-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_corbeille-bed-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_corbeille-bed-600.webp"
      }
    ]
  },
  "/img/scenes/col_bed-linen": {
    "width": 1600,
    "height": 1065,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1065,
        "src": "/img/scenes/col_bed-linen-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1065,
        "src": "/img/scenes/col_bed-linen-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_bed-linen-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_bed-linen-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 399,
        "src": "/img/scenes/col_bed-linen-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 399,
        "src": "/img/scenes/col_bed-linen-600.webp"
      }
    ]
  },
  "/img/scenes/col_bedroom-lighting": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_bedroom-lighting-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_bedroom-lighting-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_bedroom-lighting-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_bedroom-lighting-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_bedroom-lighting-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_bedroom-lighting-600.webp"
      }
    ]
  },
  "/img/scenes/col_barley-twist-bookcase": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_barley-twist-bookcase-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_barley-twist-bookcase-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_barley-twist-bookcase-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_barley-twist-bookcase-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_barley-twist-bookcase-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_barley-twist-bookcase-600.webp"
      }
    ]
  },
  "/img/scenes/col_chesterfield-chair": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_chesterfield-chair-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_chesterfield-chair-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_chesterfield-chair-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_chesterfield-chair-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_chesterfield-chair-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_chesterfield-chair-600.webp"
      }
    ]
  },
  "/img/scenes/col_butler-attire-display": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_butler-attire-display-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_butler-attire-display-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_butler-attire-display-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_butler-attire-display-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_butler-attire-display-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_butler-attire-display-600.webp"
      }
    ]
  },
  "/img/scenes/col_french-oak-doors": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_french-oak-doors-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_french-oak-doors-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_french-oak-doors-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_french-oak-doors-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_french-oak-doors-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_french-oak-doors-600.webp"
      }
    ]
  },
  "/img/scenes/col_hall-clock": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_hall-clock-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_hall-clock-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_hall-clock-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_hall-clock-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_hall-clock-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_hall-clock-600.webp"
      }
    ]
  },
  "/img/scenes/col_display-cabinet": {
    "width": 1600,
    "height": 1065,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1065,
        "src": "/img/scenes/col_display-cabinet-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1065,
        "src": "/img/scenes/col_display-cabinet-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_display-cabinet-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_display-cabinet-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 399,
        "src": "/img/scenes/col_display-cabinet-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 399,
        "src": "/img/scenes/col_display-cabinet-600.webp"
      }
    ]
  },
  "/img/scenes/col_christofle-marly": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_christofle-marly-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_christofle-marly-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_christofle-marly-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_christofle-marly-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_christofle-marly-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_christofle-marly-600.webp"
      }
    ]
  },
  "/img/scenes/col_bernardaud-volubilis": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_bernardaud-volubilis-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_bernardaud-volubilis-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_bernardaud-volubilis-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_bernardaud-volubilis-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_bernardaud-volubilis-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_bernardaud-volubilis-600.webp"
      }
    ]
  },
  "/img/scenes/col_british-porcelain": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_british-porcelain-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_british-porcelain-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_british-porcelain-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_british-porcelain-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_british-porcelain-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_british-porcelain-600.webp"
      }
    ]
  },
  "/img/scenes/col_service-plates": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_service-plates-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_service-plates-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_service-plates-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_service-plates-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_service-plates-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_service-plates-600.webp"
      }
    ]
  },
  "/img/scenes/col_silver-tea-service": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_silver-tea-service-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_silver-tea-service-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_silver-tea-service-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_silver-tea-service-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_silver-tea-service-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_silver-tea-service-600.webp"
      }
    ]
  },
  "/img/scenes/th04_theater_products_room": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/th04_theater_products_room-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/th04_theater_products_room-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/th04_theater_products_room-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/th04_theater_products_room-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/th04_theater_products_room-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/th04_theater_products_room-600.webp"
      }
    ]
  },
  "/img/scenes/th05_theater_products_guest": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/th05_theater_products_guest-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/th05_theater_products_guest-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/th05_theater_products_guest-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/th05_theater_products_guest-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/th05_theater_products_guest-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/th05_theater_products_guest-600.webp"
      }
    ]
  },
  "/img/scenes/th06_theater_products_detail": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/th06_theater_products_detail-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/th06_theater_products_detail-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/th06_theater_products_detail-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/th06_theater_products_detail-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/th06_theater_products_detail-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/th06_theater_products_detail-600.webp"
      }
    ]
  },
  "/img/scenes/rf01_rooftop_night_view": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rf01_rooftop_night_view-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rf01_rooftop_night_view-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rf01_rooftop_night_view-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rf01_rooftop_night_view-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rf01_rooftop_night_view-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rf01_rooftop_night_view-600.webp"
      }
    ]
  },
  "/img/scenes/rf02_rooftop_night_butler_guest": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rf02_rooftop_night_butler_guest-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rf02_rooftop_night_butler_guest-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rf02_rooftop_night_butler_guest-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rf02_rooftop_night_butler_guest-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rf02_rooftop_night_butler_guest-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rf02_rooftop_night_butler_guest-600.webp"
      }
    ]
  },
  "/img/scenes/rf03_rooftop_dusk_wide": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rf03_rooftop_dusk_wide-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rf03_rooftop_dusk_wide-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rf03_rooftop_dusk_wide-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rf03_rooftop_dusk_wide-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rf03_rooftop_dusk_wide-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rf03_rooftop_dusk_wide-600.webp"
      }
    ]
  },
  "/img/scenes/rf04_rooftop_night_close_railing": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rf04_rooftop_night_close_railing-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rf04_rooftop_night_close_railing-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rf04_rooftop_night_close_railing-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rf04_rooftop_night_close_railing-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rf04_rooftop_night_close_railing-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rf04_rooftop_night_close_railing-600.webp"
      }
    ]
  },
  "/img/scenes/bl01_building_dusk": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bl01_building_dusk-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bl01_building_dusk-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bl01_building_dusk-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bl01_building_dusk-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bl01_building_dusk-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bl01_building_dusk-600.webp"
      }
    ]
  },
  "/img/scenes/bl02_building_night": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bl02_building_night-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bl02_building_night-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bl02_building_night-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bl02_building_night-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bl02_building_night-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bl02_building_night-600.webp"
      }
    ]
  },
  "/img/scenes/bl03_building_entrance_day": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bl03_building_entrance_day-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bl03_building_entrance_day-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bl03_building_entrance_day-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bl03_building_entrance_day-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bl03_building_entrance_day-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bl03_building_entrance_day-600.webp"
      }
    ]
  },
  "/img/scenes/bl04_building_waterfront": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bl04_building_waterfront-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bl04_building_waterfront-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bl04_building_waterfront-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bl04_building_waterfront-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bl04_building_waterfront-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bl04_building_waterfront-600.webp"
      }
    ]
  },
  "/img/scenes/pd01_screen_awol_mwf220": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/pd01_screen_awol_mwf220-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/pd01_screen_awol_mwf220-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/pd01_screen_awol_mwf220-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/pd01_screen_awol_mwf220-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/pd01_screen_awol_mwf220-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/pd01_screen_awol_mwf220-600.webp"
      }
    ]
  },
  "/img/scenes/pd02_projector_valerion_max": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/pd02_projector_valerion_max-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/pd02_projector_valerion_max-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/pd02_projector_valerion_max-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/pd02_projector_valerion_max-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/pd02_projector_valerion_max-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/pd02_projector_valerion_max-600.webp"
      }
    ]
  },
  "/img/scenes/pd03_soundbar_jbl_bar1300m2": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/pd03_soundbar_jbl_bar1300m2-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/pd03_soundbar_jbl_bar1300m2-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/pd03_soundbar_jbl_bar1300m2-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/pd03_soundbar_jbl_bar1300m2-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/pd03_soundbar_jbl_bar1300m2-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/pd03_soundbar_jbl_bar1300m2-600.webp"
      }
    ]
  },
  "/img/scenes/jn07": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/jn07-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/jn07-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/jn07-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/jn07-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/jn07-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/jn07-600.webp"
      }
    ]
  },
  "/img/scenes/jn08": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/jn08-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/jn08-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/jn08-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/jn08-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/jn08-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/jn08-600.webp"
      }
    ]
  },
  "/img/scenes/jn09": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/jn09-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/jn09-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/jn09-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/jn09-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/jn09-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/jn09-600.webp"
      }
    ]
  },
  "/img/scenes/pg07": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg07-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg07-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg07-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg07-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg07-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg07-600.webp"
      }
    ]
  },
  "/img/scenes/pg08": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg08-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg08-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg08-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg08-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg08-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg08-600.webp"
      }
    ]
  },
  "/img/scenes/pg09": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg09-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg09-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg09-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg09-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg09-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg09-600.webp"
      }
    ]
  },
  "/img/scenes/pg10": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg10-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg10-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg10-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg10-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg10-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg10-600.webp"
      }
    ]
  },
  "/img/scenes/pg11": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg11-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg11-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg11-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg11-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg11-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg11-600.webp"
      }
    ]
  },
  "/img/scenes/pg12": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg12-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg12-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg12-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg12-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg12-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg12-600.webp"
      }
    ]
  },
  "/img/scenes/pg13": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg13-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg13-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg13-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg13-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg13-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg13-600.webp"
      }
    ]
  },
  "/img/scenes/pg14": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg14-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg14-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg14-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg14-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg14-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg14-600.webp"
      }
    ]
  },
  "/img/scenes/pg15": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg15-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg15-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg15-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg15-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg15-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg15-600.webp"
      }
    ]
  },
  "/img/scenes/pg16": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg16-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg16-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg16-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg16-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg16-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg16-600.webp"
      }
    ]
  },
  "/img/scenes/pg17": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg17-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg17-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg17-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg17-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg17-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg17-600.webp"
      }
    ]
  },
  "/img/scenes/pg18": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg18-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg18-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg18-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg18-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg18-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg18-600.webp"
      }
    ]
  },
  "/img/scenes/pg19": {
    "width": 1600,
    "height": 2213,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2213,
        "src": "/img/scenes/pg19-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2213,
        "src": "/img/scenes/pg19-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1383,
        "src": "/img/scenes/pg19-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1383,
        "src": "/img/scenes/pg19-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 830,
        "src": "/img/scenes/pg19-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 830,
        "src": "/img/scenes/pg19-600.webp"
      }
    ]
  },
  "/img/scenes/pg20": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg20-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg20-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg20-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg20-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg20-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg20-600.webp"
      }
    ]
  },
  "/img/scenes/pg21": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg21-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg21-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg21-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg21-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg21-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg21-600.webp"
      }
    ]
  },
  "/img/scenes/pg22": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg22-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg22-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg22-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg22-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg22-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg22-600.webp"
      }
    ]
  },
  "/img/scenes/pg23": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg23-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg23-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg23-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg23-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg23-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg23-600.webp"
      }
    ]
  },
  "/img/scenes/pg24": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg24-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg24-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg24-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg24-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg24-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg24-600.webp"
      }
    ]
  },
  "/img/scenes/pg26": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg26-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg26-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg26-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg26-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg26-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg26-600.webp"
      }
    ]
  },
  "/img/scenes/pg27": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg27-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg27-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg27-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg27-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg27-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg27-600.webp"
      }
    ]
  },
  "/img/scenes/pg28": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg28-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg28-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg28-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg28-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg28-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg28-600.webp"
      }
    ]
  },
  "/img/scenes/pg29": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg29-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg29-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg29-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg29-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg29-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg29-600.webp"
      }
    ]
  },
  "/img/scenes/pg30": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg30-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg30-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg30-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg30-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg30-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg30-600.webp"
      }
    ]
  },
  "/img/scenes/pg31": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg31-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg31-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg31-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg31-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg31-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg31-600.webp"
      }
    ]
  },
  "/img/scenes/pg32": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg32-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg32-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg32-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg32-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg32-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg32-600.webp"
      }
    ]
  },
  "/img/scenes/pg33": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg33-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg33-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg33-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg33-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg33-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg33-600.webp"
      }
    ]
  },
  "/img/scenes/pg34": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg34-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg34-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg34-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg34-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg34-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg34-600.webp"
      }
    ]
  },
  "/img/scenes/pg35": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg35-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg35-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg35-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg35-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg35-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg35-600.webp"
      }
    ]
  },
  "/img/scenes/pg36": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg36-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg36-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg36-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg36-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg36-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg36-600.webp"
      }
    ]
  },
  "/img/scenes/pg37": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg37-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg37-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg37-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg37-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg37-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg37-600.webp"
      }
    ]
  },
  "/img/scenes/pg38": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg38-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg38-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg38-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg38-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg38-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg38-600.webp"
      }
    ]
  },
  "/img/scenes/pg39": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg39-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg39-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg39-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg39-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg39-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg39-600.webp"
      }
    ]
  },
  "/img/scenes/pg40": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg40-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg40-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg40-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg40-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg40-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg40-600.webp"
      }
    ]
  },
  "/img/scenes/pg41": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg41-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg41-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg41-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg41-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg41-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg41-600.webp"
      }
    ]
  },
  "/img/scenes/pg42": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg42-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg42-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg42-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg42-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg42-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg42-600.webp"
      }
    ]
  },
  "/img/scenes/pg43": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg43-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg43-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg43-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg43-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg43-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg43-600.webp"
      }
    ]
  },
  "/img/scenes/pg44": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg44-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg44-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg44-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg44-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg44-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg44-600.webp"
      }
    ]
  },
  "/img/scenes/pg45": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg45-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg45-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg45-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg45-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg45-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg45-600.webp"
      }
    ]
  },
  "/img/scenes/pg46": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg46-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg46-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg46-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg46-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg46-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg46-600.webp"
      }
    ]
  },
  "/img/scenes/pg47": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg47-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg47-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg47-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg47-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg47-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg47-600.webp"
      }
    ]
  },
  "/img/scenes/pg48": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg48-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg48-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg48-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg48-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg48-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg48-600.webp"
      }
    ]
  },
  "/img/scenes/pg49": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg49-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg49-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg49-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg49-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg49-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg49-600.webp"
      }
    ]
  },
  "/img/scenes/pg50": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg50-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg50-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg50-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg50-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg50-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg50-600.webp"
      }
    ]
  },
  "/img/scenes/pg51": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg51-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg51-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg51-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg51-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg51-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg51-600.webp"
      }
    ]
  },
  "/img/scenes/pg52": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg52-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg52-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg52-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg52-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg52-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg52-600.webp"
      }
    ]
  },
  "/img/scenes/pg53": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg53-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg53-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg53-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg53-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg53-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg53-600.webp"
      }
    ]
  },
  "/img/scenes/pg54": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg54-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg54-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg54-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg54-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg54-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg54-600.webp"
      }
    ]
  },
  "/img/scenes/pg55": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg55-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg55-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg55-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg55-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg55-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg55-600.webp"
      }
    ]
  },
  "/img/scenes/pg56": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg56-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg56-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg56-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg56-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg56-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg56-600.webp"
      }
    ]
  },
  "/img/scenes/pg57": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg57-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg57-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg57-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg57-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg57-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg57-600.webp"
      }
    ]
  },
  "/img/scenes/pg58": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg58-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/pg58-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg58-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/pg58-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg58-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/pg58-600.webp"
      }
    ]
  },
  "/img/scenes/pg61": {
    "width": 1600,
    "height": 2842,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg61-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2842,
        "src": "/img/scenes/pg61-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg61-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1776,
        "src": "/img/scenes/pg61-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg61-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 1066,
        "src": "/img/scenes/pg61-600.webp"
      }
    ]
  },
  "/img/scenes/sa01": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sa01-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sa01-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa01-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa01-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa01-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa01-600.webp"
      }
    ]
  },
  "/img/scenes/sa02": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sa02-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sa02-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa02-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa02-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa02-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa02-600.webp"
      }
    ]
  },
  "/img/scenes/sa03": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sa03-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sa03-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa03-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa03-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa03-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa03-600.webp"
      }
    ]
  },
  "/img/scenes/sa04": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/sa04-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/sa04-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/sa04-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/sa04-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/sa04-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/sa04-600.webp"
      }
    ]
  },
  "/img/scenes/sa05": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sa05-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sa05-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa05-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa05-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa05-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa05-600.webp"
      }
    ]
  },
  "/img/scenes/sa06": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/sa06-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/sa06-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/sa06-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/sa06-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/sa06-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/sa06-600.webp"
      }
    ]
  },
  "/img/scenes/sa07": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sa07-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/sa07-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa07-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa07-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa07-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa07-600.webp"
      }
    ]
  },
  "/img/scenes/sa08": {
    "width": 1600,
    "height": 2400,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/sa08-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2400,
        "src": "/img/scenes/sa08-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/sa08-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/sa08-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/sa08-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/sa08-600.webp"
      }
    ]
  },
  "/img/scenes/sa09": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/sa09-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/sa09-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa09-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa09-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa09-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa09-600.webp"
      }
    ]
  },
  "/img/scenes/sa10": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/sa10-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/sa10-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa10-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa10-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa10-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa10-600.webp"
      }
    ]
  },
  "/img/scenes/sa11": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/sa11-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/sa11-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa11-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/sa11-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa11-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/sa11-600.webp"
      }
    ]
  },
  "/img/scenes/book_cover_gakken": {
    "width": 1600,
    "height": 2353,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2353,
        "src": "/img/scenes/book_cover_gakken-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2353,
        "src": "/img/scenes/book_cover_gakken-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1471,
        "src": "/img/scenes/book_cover_gakken-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1471,
        "src": "/img/scenes/book_cover_gakken-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 882,
        "src": "/img/scenes/book_cover_gakken-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 882,
        "src": "/img/scenes/book_cover_gakken-600.webp"
      }
    ]
  },
  "/img/scenes/col_knight-armor_full": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_knight-armor_full-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_knight-armor_full-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_knight-armor_full-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_knight-armor_full-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_knight-armor_full-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_knight-armor_full-600.webp"
      }
    ]
  },
  "/img/scenes/col_knight-armor_upper": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_knight-armor_upper-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_knight-armor_upper-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_knight-armor_upper-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_knight-armor_upper-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_knight-armor_upper-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_knight-armor_upper-600.webp"
      }
    ]
  },
  "/img/scenes/col_knight-armor_base": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_knight-armor_base-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/col_knight-armor_base-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_knight-armor_base-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/col_knight-armor_base-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_knight-armor_base-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/col_knight-armor_base-600.webp"
      }
    ]
  },
  "/img/scenes/bk01_book_billboard": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/bk01_book_billboard-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/bk01_book_billboard-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/bk01_book_billboard-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/bk01_book_billboard-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/bk01_book_billboard-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/bk01_book_billboard-600.webp"
      }
    ]
  },
  "/img/scenes/bk02_book_in_gloved_hands": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bk02_book_in_gloved_hands-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bk02_book_in_gloved_hands-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bk02_book_in_gloved_hands-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bk02_book_in_gloved_hands-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bk02_book_in_gloved_hands-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bk02_book_in_gloved_hands-600.webp"
      }
    ]
  },
  "/img/scenes/bk03_book_on_tea_table": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bk03_book_on_tea_table-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bk03_book_on_tea_table-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bk03_book_on_tea_table-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bk03_book_on_tea_table-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bk03_book_on_tea_table-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bk03_book_on_tea_table-600.webp"
      }
    ]
  },
  "/img/scenes/bk10_owner_holding_book_wide": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/bk10_owner_holding_book_wide-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/bk10_owner_holding_book_wide-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/bk10_owner_holding_book_wide-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/bk10_owner_holding_book_wide-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/bk10_owner_holding_book_wide-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/bk10_owner_holding_book_wide-600.webp"
      }
    ]
  },
  "/img/scenes/bk11_owner_holding_book": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bk11_owner_holding_book-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bk11_owner_holding_book-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bk11_owner_holding_book-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bk11_owner_holding_book-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bk11_owner_holding_book-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bk11_owner_holding_book-600.webp"
      }
    ]
  },
  "/img/scenes/at01_tailcoat_full": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at01_tailcoat_full-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at01_tailcoat_full-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at01_tailcoat_full-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at01_tailcoat_full-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at01_tailcoat_full-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at01_tailcoat_full-600.webp"
      }
    ]
  },
  "/img/scenes/at02_tailcoat_whitetie_closeup": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at02_tailcoat_whitetie_closeup-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at02_tailcoat_whitetie_closeup-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at02_tailcoat_whitetie_closeup-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at02_tailcoat_whitetie_closeup-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at02_tailcoat_whitetie_closeup-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at02_tailcoat_whitetie_closeup-600.webp"
      }
    ]
  },
  "/img/scenes/at03_tuxedo_full": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at03_tuxedo_full-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at03_tuxedo_full-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at03_tuxedo_full-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at03_tuxedo_full-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at03_tuxedo_full-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at03_tuxedo_full-600.webp"
      }
    ]
  },
  "/img/scenes/at04_blacktie_closeup": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at04_blacktie_closeup-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at04_blacktie_closeup-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at04_blacktie_closeup-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at04_blacktie_closeup-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at04_blacktie_closeup-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at04_blacktie_closeup-600.webp"
      }
    ]
  },
  "/img/scenes/at05_morning_necktie_closeup": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at05_morning_necktie_closeup-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at05_morning_necktie_closeup-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at05_morning_necktie_closeup-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at05_morning_necktie_closeup-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at05_morning_necktie_closeup-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at05_morning_necktie_closeup-600.webp"
      }
    ]
  },
  "/img/scenes/at06_white_gloves_tray": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at06_white_gloves_tray-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at06_white_gloves_tray-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at06_white_gloves_tray-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at06_white_gloves_tray-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at06_white_gloves_tray-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at06_white_gloves_tray-600.webp"
      }
    ]
  },
  "/img/scenes/at07_top_hat_in_hand": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at07_top_hat_in_hand-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at07_top_hat_in_hand-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at07_top_hat_in_hand-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at07_top_hat_in_hand-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at07_top_hat_in_hand-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at07_top_hat_in_hand-600.webp"
      }
    ]
  },
  "/img/scenes/at08_wing_collar_closeup": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at08_wing_collar_closeup-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/at08_wing_collar_closeup-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at08_wing_collar_closeup-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/at08_wing_collar_closeup-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at08_wing_collar_closeup-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/at08_wing_collar_closeup-600.webp"
      }
    ]
  },
  "/img/scenes/bl05_building_night_grand": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/bl05_building_night_grand-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/bl05_building_night_grand-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/bl05_building_night_grand-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/bl05_building_night_grand-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/bl05_building_night_grand-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/bl05_building_night_grand-600.webp"
      }
    ]
  },
  "/img/scenes/bl06_building_entrance_night": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bl06_building_entrance_night-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/bl06_building_entrance_night-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bl06_building_entrance_night-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/bl06_building_entrance_night-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bl06_building_entrance_night-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/bl06_building_entrance_night-600.webp"
      }
    ]
  },
  "/img/scenes/mt01_meeting_dining_four": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/mt01_meeting_dining_four-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/mt01_meeting_dining_four-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/mt01_meeting_dining_four-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/mt01_meeting_dining_four-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/mt01_meeting_dining_four-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/mt01_meeting_dining_four-600.webp"
      }
    ]
  },
  "/img/scenes/mt02_meeting_dining_close": {
    "width": 1600,
    "height": 2399,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/mt02_meeting_dining_close-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2399,
        "src": "/img/scenes/mt02_meeting_dining_close-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/mt02_meeting_dining_close-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1500,
        "src": "/img/scenes/mt02_meeting_dining_close-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/mt02_meeting_dining_close-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 900,
        "src": "/img/scenes/mt02_meeting_dining_close-600.webp"
      }
    ]
  },
  "/img/scenes/st01_studio_shoot_dining": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/st01_studio_shoot_dining-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/st01_studio_shoot_dining-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/st01_studio_shoot_dining-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/st01_studio_shoot_dining-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/st01_studio_shoot_dining-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/st01_studio_shoot_dining-600.webp"
      }
    ]
  },
  "/img/scenes/st02_studio_shoot_lounge": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/st02_studio_shoot_lounge-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/st02_studio_shoot_lounge-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/st02_studio_shoot_lounge-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/st02_studio_shoot_lounge-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/st02_studio_shoot_lounge-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/st02_studio_shoot_lounge-600.webp"
      }
    ]
  },
  "/img/scenes/st03_wardrobe_fitting": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/st03_wardrobe_fitting-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/st03_wardrobe_fitting-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/st03_wardrobe_fitting-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/st03_wardrobe_fitting-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/st03_wardrobe_fitting-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/st03_wardrobe_fitting-600.webp"
      }
    ]
  },
  "/img/scenes/st04_studio_hero_wide": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/st04_studio_hero_wide-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/st04_studio_hero_wide-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/st04_studio_hero_wide-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/st04_studio_hero_wide-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/st04_studio_hero_wide-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/st04_studio_hero_wide-600.webp"
      }
    ]
  },
  "/img/scenes/th10_theater_lounge_screen": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/th10_theater_lounge_screen-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/th10_theater_lounge_screen-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/th10_theater_lounge_screen-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/th10_theater_lounge_screen-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/th10_theater_lounge_screen-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/th10_theater_lounge_screen-600.webp"
      }
    ]
  },
  "/img/scenes/cu_maria-theresa-chandelier": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/cu_maria-theresa-chandelier-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/cu_maria-theresa-chandelier-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/cu_maria-theresa-chandelier-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/cu_maria-theresa-chandelier-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/cu_maria-theresa-chandelier-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/cu_maria-theresa-chandelier-600.webp"
      }
    ]
  },
  "/img/scenes/cu_bradley-yew-table": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/cu_bradley-yew-table-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/cu_bradley-yew-table-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/cu_bradley-yew-table-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/cu_bradley-yew-table-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/cu_bradley-yew-table-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/cu_bradley-yew-table-600.webp"
      }
    ]
  },
  "/img/scenes/cu_twin-pedestal-desk": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/cu_twin-pedestal-desk-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/cu_twin-pedestal-desk-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/cu_twin-pedestal-desk-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/cu_twin-pedestal-desk-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/cu_twin-pedestal-desk-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/cu_twin-pedestal-desk-600.webp"
      }
    ]
  },
  "/img/scenes/cu_french-oak-doors": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/cu_french-oak-doors-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/cu_french-oak-doors-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/cu_french-oak-doors-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/cu_french-oak-doors-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/cu_french-oak-doors-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/cu_french-oak-doors-600.webp"
      }
    ]
  },
  "/img/scenes/cu_fireplace-mantel": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/cu_fireplace-mantel-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/cu_fireplace-mantel-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/cu_fireplace-mantel-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/cu_fireplace-mantel-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/cu_fireplace-mantel-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/cu_fireplace-mantel-600.webp"
      }
    ]
  },
  "/img/scenes/fl01_film_location": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/fl01_film_location-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/fl01_film_location-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/fl01_film_location-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/fl01_film_location-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/fl01_film_location-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/fl01_film_location-600.webp"
      }
    ]
  },
  "/img/scenes/st01m_studio_shoot_dining": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/st01m_studio_shoot_dining-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/st01m_studio_shoot_dining-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/st01m_studio_shoot_dining-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/st01m_studio_shoot_dining-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/st01m_studio_shoot_dining-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/st01m_studio_shoot_dining-600.webp"
      }
    ]
  },
  "/img/scenes/st02m_studio_shoot_lounge": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/st02m_studio_shoot_lounge-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/st02m_studio_shoot_lounge-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/st02m_studio_shoot_lounge-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/st02m_studio_shoot_lounge-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/st02m_studio_shoot_lounge-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/st02m_studio_shoot_lounge-600.webp"
      }
    ]
  },
  "/img/scenes/hb_a01_study_desk": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_a01_study_desk-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_a01_study_desk-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_a01_study_desk-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_a01_study_desk-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_a01_study_desk-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_a01_study_desk-600.webp"
      }
    ]
  },
  "/img/scenes/iv01_interview_study": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/iv01_interview_study-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/iv01_interview_study-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/iv01_interview_study-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/iv01_interview_study-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/iv01_interview_study-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/iv01_interview_study-600.webp"
      }
    ]
  },
  "/img/scenes/iv03_recording_dining": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/iv03_recording_dining-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/iv03_recording_dining-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/iv03_recording_dining-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/iv03_recording_dining-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/iv03_recording_dining-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/iv03_recording_dining-600.webp"
      }
    ]
  },
  "/img/scenes/rc01_recital_lounge": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rc01_recital_lounge-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rc01_recital_lounge-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rc01_recital_lounge-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rc01_recital_lounge-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rc01_recital_lounge-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rc01_recital_lounge-600.webp"
      }
    ]
  },
  "/img/scenes/hb_a05_hall_wide": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_a05_hall_wide-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_a05_hall_wide-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_a05_hall_wide-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_a05_hall_wide-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_a05_hall_wide-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_a05_hall_wide-600.webp"
      }
    ]
  },
  "/img/scenes/hb_a07_wardrobe": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_a07_wardrobe-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_a07_wardrobe-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_a07_wardrobe-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_a07_wardrobe-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_a07_wardrobe-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_a07_wardrobe-600.webp"
      }
    ]
  },
  "/img/scenes/hb_a08_plates_flatlay": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_a08_plates_flatlay-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_a08_plates_flatlay-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_a08_plates_flatlay-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_a08_plates_flatlay-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_a08_plates_flatlay-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_a08_plates_flatlay-600.webp"
      }
    ]
  },
  "/img/scenes/hb_b01_study_letter": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b01_study_letter-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b01_study_letter-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b01_study_letter-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b01_study_letter-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b01_study_letter-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b01_study_letter-600.webp"
      }
    ]
  },
  "/img/scenes/hb_b07_wardrobe_choose_coat": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b07_wardrobe_choose_coat-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b07_wardrobe_choose_coat-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b07_wardrobe_choose_coat-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b07_wardrobe_choose_coat-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b07_wardrobe_choose_coat-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b07_wardrobe_choose_coat-600.webp"
      }
    ]
  },
  "/img/scenes/hb_b11_hall_arrival": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b11_hall_arrival-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b11_hall_arrival-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b11_hall_arrival-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b11_hall_arrival-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b11_hall_arrival-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b11_hall_arrival-600.webp"
      }
    ]
  },
  "/img/scenes/hb_drive01_door_open": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_drive01_door_open-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_drive01_door_open-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_drive01_door_open-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_drive01_door_open-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_drive01_door_open-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_drive01_door_open-600.webp"
      }
    ]
  },
  "/img/scenes/hb_drive05_car_only": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_drive05_car_only-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_drive05_car_only-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_drive05_car_only-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_drive05_car_only-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_drive05_car_only-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_drive05_car_only-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s01_dining_tea_service": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s01_dining_tea_service-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s01_dining_tea_service-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s01_dining_tea_service-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s01_dining_tea_service-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s01_dining_tea_service-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s01_dining_tea_service-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s02_dining_afternoon_tea": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s02_dining_afternoon_tea-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s02_dining_afternoon_tea-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s02_dining_afternoon_tea-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s02_dining_afternoon_tea-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s02_dining_afternoon_tea-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s02_dining_afternoon_tea-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s03_dining_table_manners": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s03_dining_table_manners-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s03_dining_table_manners-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s03_dining_table_manners-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s03_dining_table_manners-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s03_dining_table_manners-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s03_dining_table_manners-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s10_door_welcome": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s10_door_welcome-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s10_door_welcome-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s10_door_welcome-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s10_door_welcome-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s10_door_welcome-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s10_door_welcome-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s15_watch_gift": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s15_watch_gift-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s15_watch_gift-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s15_watch_gift-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s15_watch_gift-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s15_watch_gift-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s15_watch_gift-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s19_studio_portrait": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s19_studio_portrait-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s19_studio_portrait-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s19_studio_portrait-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s19_studio_portrait-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s19_studio_portrait-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s19_studio_portrait-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s22_buddy_walk": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s22_buddy_walk-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s22_buddy_walk-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s22_buddy_walk-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s22_buddy_walk-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s22_buddy_walk-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s22_buddy_walk-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s24_hero_wide": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s24_hero_wide-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s24_hero_wide-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s24_hero_wide-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s24_hero_wide-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s24_hero_wide-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s24_hero_wide-600.webp"
      }
    ]
  },
  "/img/scenes/hb_at01_tailcoat_full": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_at01_tailcoat_full-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_at01_tailcoat_full-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_at01_tailcoat_full-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_at01_tailcoat_full-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_at01_tailcoat_full-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_at01_tailcoat_full-600.webp"
      }
    ]
  },
  "/img/scenes/hb_b08_wardrobe_top_hat": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b08_wardrobe_top_hat-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b08_wardrobe_top_hat-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b08_wardrobe_top_hat-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b08_wardrobe_top_hat-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b08_wardrobe_top_hat-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b08_wardrobe_top_hat-600.webp"
      }
    ]
  },
  "/img/scenes/hb_b09_glove_fitting": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b09_glove_fitting-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b09_glove_fitting-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b09_glove_fitting-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b09_glove_fitting-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b09_glove_fitting-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b09_glove_fitting-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s14_cup_hands_gift": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s14_cup_hands_gift-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s14_cup_hands_gift-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s14_cup_hands_gift-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s14_cup_hands_gift-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s14_cup_hands_gift-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s14_cup_hands_gift-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s16_footman_dressing": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s16_footman_dressing-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s16_footman_dressing-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s16_footman_dressing-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s16_footman_dressing-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s16_footman_dressing-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s16_footman_dressing-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s18_footman_bow": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s18_footman_bow-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s18_footman_bow-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s18_footman_bow-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s18_footman_bow-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s18_footman_bow-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s18_footman_bow-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s20_studio_bridal": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s20_studio_bridal-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s20_studio_bridal-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s20_studio_bridal-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s20_studio_bridal-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s20_studio_bridal-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s20_studio_bridal-600.webp"
      }
    ]
  },
  "/img/scenes/iv02_interview_lounge": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/iv02_interview_lounge-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/iv02_interview_lounge-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/iv02_interview_lounge-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/iv02_interview_lounge-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/iv02_interview_lounge-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/iv02_interview_lounge-600.webp"
      }
    ]
  },
  "/img/scenes/sr01_showroom_dining": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/sr01_showroom_dining-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/sr01_showroom_dining-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/sr01_showroom_dining-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/sr01_showroom_dining-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/sr01_showroom_dining-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/sr01_showroom_dining-600.webp"
      }
    ]
  },
  "/img/scenes/hb_b10_cabinet_tea_choice": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b10_cabinet_tea_choice-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b10_cabinet_tea_choice-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b10_cabinet_tea_choice-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b10_cabinet_tea_choice-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b10_cabinet_tea_choice-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b10_cabinet_tea_choice-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s04_lounge_reading": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s04_lounge_reading-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s04_lounge_reading-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s04_lounge_reading-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s04_lounge_reading-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s04_lounge_reading-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s04_lounge_reading-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s05_lounge_fireplace_rose": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s05_lounge_fireplace_rose-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s05_lounge_fireplace_rose-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s05_lounge_fireplace_rose-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s05_lounge_fireplace_rose-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s05_lounge_fireplace_rose-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s05_lounge_fireplace_rose-600.webp"
      }
    ]
  },
  "/img/scenes/hb_a02_study_shelf": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_a02_study_shelf-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_a02_study_shelf-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_a02_study_shelf-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_a02_study_shelf-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_a02_study_shelf-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_a02_study_shelf-600.webp"
      }
    ]
  },
  "/img/scenes/hb_a06_cabinet": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_a06_cabinet-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_a06_cabinet-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_a06_cabinet-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_a06_cabinet-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_a06_cabinet-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_a06_cabinet-600.webp"
      }
    ]
  },
  "/img/scenes/hb_b02_study_reading": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b02_study_reading-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b02_study_reading-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b02_study_reading-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b02_study_reading-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b02_study_reading-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b02_study_reading-600.webp"
      }
    ]
  },
  "/img/scenes/hb_b12_lounge_two_ladies": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b12_lounge_two_ladies-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b12_lounge_two_ladies-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b12_lounge_two_ladies-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b12_lounge_two_ladies-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b12_lounge_two_ladies-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b12_lounge_two_ladies-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s13_tea_hands_receive": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s13_tea_hands_receive-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s13_tea_hands_receive-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s13_tea_hands_receive-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s13_tea_hands_receive-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s13_tea_hands_receive-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s13_tea_hands_receive-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s23_night_candle": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s23_night_candle-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s23_night_candle-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s23_night_candle-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s23_night_candle-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s23_night_candle-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s23_night_candle-600.webp"
      }
    ]
  },
  "/img/scenes/hb_02_1786973020497": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_02_1786973020497-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_02_1786973020497-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_02_1786973020497-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_02_1786973020497-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_02_1786973020497-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_02_1786973020497-600.webp"
      }
    ]
  },
  "/img/scenes/hb_15_MEITU_20260817_223503840": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_15_MEITU_20260817_223503840-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_15_MEITU_20260817_223503840-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_15_MEITU_20260817_223503840-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_15_MEITU_20260817_223503840-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_15_MEITU_20260817_223503840-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_15_MEITU_20260817_223503840-600.webp"
      }
    ]
  },
  "/img/scenes/hb_at06_white_gloves_tray": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_at06_white_gloves_tray-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_at06_white_gloves_tray-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_at06_white_gloves_tray-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_at06_white_gloves_tray-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_at06_white_gloves_tray-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_at06_white_gloves_tray-600.webp"
      }
    ]
  },
  "/img/scenes/hb_01_1786972970388": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_01_1786972970388-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_01_1786972970388-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_01_1786972970388-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_01_1786972970388-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_01_1786972970388-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_01_1786972970388-600.webp"
      }
    ]
  },
  "/img/scenes/hb_b06_bedside_goodnight_tea": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b06_bedside_goodnight_tea-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b06_bedside_goodnight_tea-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b06_bedside_goodnight_tea-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b06_bedside_goodnight_tea-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b06_bedside_goodnight_tea-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b06_bedside_goodnight_tea-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s06_lounge_headcare": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s06_lounge_headcare-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s06_lounge_headcare-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s06_lounge_headcare-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s06_lounge_headcare-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s06_lounge_headcare-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s06_lounge_headcare-600.webp"
      }
    ]
  },
  "/img/scenes/ap01_group_bow": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap01_group_bow-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap01_group_bow-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap01_group_bow-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap01_group_bow-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap01_group_bow-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap01_group_bow-600.webp"
      }
    ]
  },
  "/img/scenes/ap02_tea_lesson": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap02_tea_lesson-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap02_tea_lesson-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap02_tea_lesson-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap02_tea_lesson-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap02_tea_lesson-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap02_tea_lesson-600.webp"
      }
    ]
  },
  "/img/scenes/ap03_gloves_fitting": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap03_gloves_fitting-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap03_gloves_fitting-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap03_gloves_fitting-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap03_gloves_fitting-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap03_gloves_fitting-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap03_gloves_fitting-600.webp"
      }
    ]
  },
  "/img/scenes/ap04_silverware": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap04_silverware-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap04_silverware-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap04_silverware-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap04_silverware-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap04_silverware-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap04_silverware-600.webp"
      }
    ]
  },
  "/img/scenes/ap05_door_welcome": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap05_door_welcome-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap05_door_welcome-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap05_door_welcome-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap05_door_welcome-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap05_door_welcome-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap05_door_welcome-600.webp"
      }
    ]
  },
  "/img/scenes/ap05_door_welcome_source": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap05_door_welcome_source-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap05_door_welcome_source-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap05_door_welcome_source-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap05_door_welcome_source-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap05_door_welcome_source-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap05_door_welcome_source-600.webp"
      }
    ]
  },
  "/img/scenes/ap06_tray_walk": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap06_tray_walk-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap06_tray_walk-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap06_tray_walk-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap06_tray_walk-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap06_tray_walk-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap06_tray_walk-600.webp"
      }
    ]
  },
  "/img/scenes/ap07_family_photo": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap07_family_photo-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap07_family_photo-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap07_family_photo-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap07_family_photo-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap07_family_photo-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap07_family_photo-600.webp"
      }
    ]
  },
  "/img/scenes/ap08_study_letter": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap08_study_letter-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap08_study_letter-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap08_study_letter-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap08_study_letter-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap08_study_letter-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap08_study_letter-600.webp"
      }
    ]
  },
  "/img/scenes/ap09_gift_moment": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap09_gift_moment-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap09_gift_moment-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap09_gift_moment-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap09_gift_moment-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap09_gift_moment-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap09_gift_moment-600.webp"
      }
    ]
  },
  "/img/scenes/ap10_wardrobe_choose": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap10_wardrobe_choose-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ap10_wardrobe_choose-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap10_wardrobe_choose-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ap10_wardrobe_choose-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap10_wardrobe_choose-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ap10_wardrobe_choose-600.webp"
      }
    ]
  },
  "/img/scenes/bc01_buddy_contract": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/bc01_buddy_contract-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/bc01_buddy_contract-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/bc01_buddy_contract-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/bc01_buddy_contract-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/bc01_buddy_contract-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/bc01_buddy_contract-600.webp"
      }
    ]
  },
  "/img/scenes/hb_17_MEITU_20260817_223704244": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_17_MEITU_20260817_223704244-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_17_MEITU_20260817_223704244-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_17_MEITU_20260817_223704244-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_17_MEITU_20260817_223704244-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_17_MEITU_20260817_223704244-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_17_MEITU_20260817_223704244-600.webp"
      }
    ]
  },
  "/img/scenes/hb_b03_study_globe": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b03_study_globe-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b03_study_globe-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b03_study_globe-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b03_study_globe-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b03_study_globe-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b03_study_globe-600.webp"
      }
    ]
  },
  "/img/scenes/hb_drive04_return": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_drive04_return-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_drive04_return-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_drive04_return-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_drive04_return-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_drive04_return-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_drive04_return-600.webp"
      }
    ]
  },
  "/img/scenes/hb_pg40": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_pg40-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_pg40-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_pg40-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_pg40-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_pg40-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_pg40-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s07_bedroom_rest": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s07_bedroom_rest-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s07_bedroom_rest-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s07_bedroom_rest-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s07_bedroom_rest-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s07_bedroom_rest-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s07_bedroom_rest-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s08_bedroom_morning_tea": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s08_bedroom_morning_tea-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s08_bedroom_morning_tea-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s08_bedroom_morning_tea-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s08_bedroom_morning_tea-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s08_bedroom_morning_tea-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s08_bedroom_morning_tea-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s11_door_farewell": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s11_door_farewell-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s11_door_farewell-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s11_door_farewell-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s11_door_farewell-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s11_door_farewell-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s11_door_farewell-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s17_footman_tea_practice": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s17_footman_tea_practice-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s17_footman_tea_practice-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s17_footman_tea_practice-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s17_footman_tea_practice-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s17_footman_tea_practice-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s17_footman_tea_practice-600.webp"
      }
    ]
  },
  "/img/scenes/hb_s21_studio_friends": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s21_studio_friends-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_s21_studio_friends-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s21_studio_friends-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_s21_studio_friends-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s21_studio_friends-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_s21_studio_friends-600.webp"
      }
    ]
  },
  "/img/scenes/hb_at05_morning_necktie_closeup": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_at05_morning_necktie_closeup-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_at05_morning_necktie_closeup-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_at05_morning_necktie_closeup-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_at05_morning_necktie_closeup-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_at05_morning_necktie_closeup-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_at05_morning_necktie_closeup-600.webp"
      }
    ]
  },
  "/img/scenes/hb_b04_study_typewriter": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b04_study_typewriter-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_b04_study_typewriter-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b04_study_typewriter-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_b04_study_typewriter-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b04_study_typewriter-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_b04_study_typewriter-600.webp"
      }
    ]
  },
  "/img/scenes/hb_bk10_owner_holding_book_wide": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_bk10_owner_holding_book_wide-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_bk10_owner_holding_book_wide-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_bk10_owner_holding_book_wide-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_bk10_owner_holding_book_wide-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_bk10_owner_holding_book_wide-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_bk10_owner_holding_book_wide-600.webp"
      }
    ]
  },
  "/img/scenes/hb_bl05_building_night_grand": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_bl05_building_night_grand-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/hb_bl05_building_night_grand-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_bl05_building_night_grand-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/hb_bl05_building_night_grand-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_bl05_building_night_grand-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/hb_bl05_building_night_grand-600.webp"
      }
    ]
  },
  "/img/scenes/bk20_owner_with_book_real": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/bk20_owner_with_book_real-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/bk20_owner_with_book_real-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/bk20_owner_with_book_real-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/bk20_owner_with_book_real-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/bk20_owner_with_book_real-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/bk20_owner_with_book_real-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_01_home_hero": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_01_home_hero-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_01_home_hero-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_01_home_hero-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_01_home_hero-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_01_home_hero-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_01_home_hero-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_02_butler_study": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_02_butler_study-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_02_butler_study-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_02_butler_study-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_02_butler_study-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_02_butler_study-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_02_butler_study-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_03_tableware": {
    "width": 1600,
    "height": 1600,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1600,
        "src": "/img/scenes/rs_association_03_tableware-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1600,
        "src": "/img/scenes/rs_association_03_tableware-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1000,
        "src": "/img/scenes/rs_association_03_tableware-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1000,
        "src": "/img/scenes/rs_association_03_tableware-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 600,
        "src": "/img/scenes/rs_association_03_tableware-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 600,
        "src": "/img/scenes/rs_association_03_tableware-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_04_footman_entrance": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_04_footman_entrance-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_04_footman_entrance-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_04_footman_entrance-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_04_footman_entrance-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_04_footman_entrance-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_04_footman_entrance-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_05_gathering": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_05_gathering-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_05_gathering-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_05_gathering-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_05_gathering-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_05_gathering-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_05_gathering-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_06_associate_training": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_06_associate_training-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_06_associate_training-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_06_associate_training-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_06_associate_training-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_06_associate_training-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_06_associate_training-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_07_master_butler": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_07_master_butler-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_07_master_butler-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_07_master_butler-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_07_master_butler-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_07_master_butler-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_07_master_butler-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_08_seminar": {
    "width": 1600,
    "height": 2133,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2133,
        "src": "/img/scenes/rs_association_08_seminar-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2133,
        "src": "/img/scenes/rs_association_08_seminar-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1333,
        "src": "/img/scenes/rs_association_08_seminar-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1333,
        "src": "/img/scenes/rs_association_08_seminar-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 800,
        "src": "/img/scenes/rs_association_08_seminar-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 800,
        "src": "/img/scenes/rs_association_08_seminar-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_09_logo": {
    "width": 1600,
    "height": 2017,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2017,
        "src": "/img/scenes/rs_association_09_logo-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2017,
        "src": "/img/scenes/rs_association_09_logo-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1261,
        "src": "/img/scenes/rs_association_09_logo-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1261,
        "src": "/img/scenes/rs_association_09_logo-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 756,
        "src": "/img/scenes/rs_association_09_logo-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 756,
        "src": "/img/scenes/rs_association_09_logo-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_01_intro_welcome": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_01_intro_welcome-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_01_intro_welcome-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_01_intro_welcome-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_01_intro_welcome-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_01_intro_welcome-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_01_intro_welcome-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_02_entrance_tea_tray": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_02_entrance_tea_tray-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_02_entrance_tea_tray-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_02_entrance_tea_tray-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_02_entrance_tea_tray-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_02_entrance_tea_tray-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_02_entrance_tea_tray-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_03_promise_household": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_03_promise_household-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_03_promise_household-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_03_promise_household-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_03_promise_household-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_03_promise_household-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_03_promise_household-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_04_promise_business": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_04_promise_business-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_04_promise_business-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_04_promise_business-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_04_promise_business-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_04_promise_business-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_04_promise_business-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_05_promise_occasion": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_05_promise_occasion-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_05_promise_occasion-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_05_promise_occasion-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_05_promise_occasion-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_05_promise_occasion-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_05_promise_occasion-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_06_night_residence": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_06_night_residence-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_06_night_residence-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_06_night_residence-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_06_night_residence-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_06_night_residence-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_06_night_residence-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_07_day_butler_business": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_07_day_butler_business-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_07_day_butler_business-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_07_day_butler_business-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_07_day_butler_business-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_07_day_butler_business-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_07_day_butler_business-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_01_hero_butlers": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_01_hero_butlers-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_01_hero_butlers-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_01_hero_butlers-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_01_hero_butlers-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_01_hero_butlers-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_01_hero_butlers-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_02_curriculum": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_02_curriculum-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_02_curriculum-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_02_curriculum-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_02_curriculum-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_02_curriculum-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_02_curriculum-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_03_odaiba_facility": {
    "width": 1600,
    "height": 853,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 853,
        "src": "/img/scenes/rs_academy_03_odaiba_facility-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 853,
        "src": "/img/scenes/rs_academy_03_odaiba_facility-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 533,
        "src": "/img/scenes/rs_academy_03_odaiba_facility-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 533,
        "src": "/img/scenes/rs_academy_03_odaiba_facility-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 320,
        "src": "/img/scenes/rs_academy_03_odaiba_facility-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 320,
        "src": "/img/scenes/rs_academy_03_odaiba_facility-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_04_classroom": {
    "width": 1600,
    "height": 1200,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_04_classroom-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_04_classroom-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_04_classroom-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_04_classroom-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_04_classroom-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_04_classroom-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_05_theory": {
    "width": 1600,
    "height": 1040,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1040,
        "src": "/img/scenes/rs_academy_05_theory-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1040,
        "src": "/img/scenes/rs_academy_05_theory-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 650,
        "src": "/img/scenes/rs_academy_05_theory-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 650,
        "src": "/img/scenes/rs_academy_05_theory-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 390,
        "src": "/img/scenes/rs_academy_05_theory-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 390,
        "src": "/img/scenes/rs_academy_05_theory-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_06_roleplay": {
    "width": 1600,
    "height": 1040,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1040,
        "src": "/img/scenes/rs_academy_06_roleplay-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1040,
        "src": "/img/scenes/rs_academy_06_roleplay-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 650,
        "src": "/img/scenes/rs_academy_06_roleplay-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 650,
        "src": "/img/scenes/rs_academy_06_roleplay-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 390,
        "src": "/img/scenes/rs_academy_06_roleplay-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 390,
        "src": "/img/scenes/rs_academy_06_roleplay-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_07_tea_practice": {
    "width": 1600,
    "height": 1120,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1120,
        "src": "/img/scenes/rs_academy_07_tea_practice-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1120,
        "src": "/img/scenes/rs_academy_07_tea_practice-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 700,
        "src": "/img/scenes/rs_academy_07_tea_practice-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 700,
        "src": "/img/scenes/rs_academy_07_tea_practice-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 420,
        "src": "/img/scenes/rs_academy_07_tea_practice-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 420,
        "src": "/img/scenes/rs_academy_07_tea_practice-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_01_top_hat": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/rs_bell_01_top_hat-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/rs_bell_01_top_hat-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/rs_bell_01_top_hat-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/rs_bell_01_top_hat-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_01_top_hat-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_01_top_hat-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_02_portrait_tea_tray": {
    "width": 1600,
    "height": 2402,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2402,
        "src": "/img/scenes/rs_bell_02_portrait_tea_tray-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2402,
        "src": "/img/scenes/rs_bell_02_portrait_tea_tray-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1501,
        "src": "/img/scenes/rs_bell_02_portrait_tea_tray-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1501,
        "src": "/img/scenes/rs_bell_02_portrait_tea_tray-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 901,
        "src": "/img/scenes/rs_bell_02_portrait_tea_tray-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 901,
        "src": "/img/scenes/rs_bell_02_portrait_tea_tray-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_03_salon_dining": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/rs_bell_03_salon_dining-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/rs_bell_03_salon_dining-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/rs_bell_03_salon_dining-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/rs_bell_03_salon_dining-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_03_salon_dining-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_03_salon_dining-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_04_butler_daily": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_04_butler_daily-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_04_butler_daily-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_04_butler_daily-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_04_butler_daily-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_04_butler_daily-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_04_butler_daily-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_05_table_manner": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rs_bell_05_table_manner-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rs_bell_05_table_manner-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rs_bell_05_table_manner-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rs_bell_05_table_manner-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_05_table_manner-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_05_table_manner-600.webp"
      }
    ]
  },
  "/img/scenes/rs_tabishitsuji_01_harbor_town": {
    "width": 1600,
    "height": 1200,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_tabishitsuji_01_harbor_town-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_tabishitsuji_01_harbor_town-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_tabishitsuji_01_harbor_town-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_tabishitsuji_01_harbor_town-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_tabishitsuji_01_harbor_town-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_tabishitsuji_01_harbor_town-600.webp"
      }
    ]
  },
  "/img/scenes/rs_tabishitsuji_02_strait_view": {
    "width": 1600,
    "height": 1200,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_tabishitsuji_02_strait_view-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_tabishitsuji_02_strait_view-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_tabishitsuji_02_strait_view-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_tabishitsuji_02_strait_view-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_tabishitsuji_02_strait_view-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_tabishitsuji_02_strait_view-600.webp"
      }
    ]
  },
  "/img/scenes/rs_tabishitsuji_03_mont_saint_michel": {
    "width": 1600,
    "height": 2133,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2133,
        "src": "/img/scenes/rs_tabishitsuji_03_mont_saint_michel-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2133,
        "src": "/img/scenes/rs_tabishitsuji_03_mont_saint_michel-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1333,
        "src": "/img/scenes/rs_tabishitsuji_03_mont_saint_michel-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1333,
        "src": "/img/scenes/rs_tabishitsuji_03_mont_saint_michel-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 800,
        "src": "/img/scenes/rs_tabishitsuji_03_mont_saint_michel-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 800,
        "src": "/img/scenes/rs_tabishitsuji_03_mont_saint_michel-600.webp"
      }
    ]
  },
  "/img/scenes/rs_tabishitsuji_04_paris_night": {
    "width": 1600,
    "height": 1789,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1789,
        "src": "/img/scenes/rs_tabishitsuji_04_paris_night-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1789,
        "src": "/img/scenes/rs_tabishitsuji_04_paris_night-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1118,
        "src": "/img/scenes/rs_tabishitsuji_04_paris_night-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1118,
        "src": "/img/scenes/rs_tabishitsuji_04_paris_night-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 671,
        "src": "/img/scenes/rs_tabishitsuji_04_paris_night-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 671,
        "src": "/img/scenes/rs_tabishitsuji_04_paris_night-600.webp"
      }
    ]
  },
  "/img/scenes/rs_tabishitsuji_05_hill_town": {
    "width": 1600,
    "height": 1200,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_tabishitsuji_05_hill_town-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_tabishitsuji_05_hill_town-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_tabishitsuji_05_hill_town-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_tabishitsuji_05_hill_town-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_tabishitsuji_05_hill_town-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_tabishitsuji_05_hill_town-600.webp"
      }
    ]
  },
  "/img/scenes/book_on_charger_plate": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/book_on_charger_plate-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/scenes/book_on_charger_plate-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/book_on_charger_plate-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/book_on_charger_plate-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/book_on_charger_plate-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/book_on_charger_plate-600.webp"
      }
    ]
  },
  "/img/scenes/book_on_study_desk": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/book_on_study_desk-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/book_on_study_desk-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/book_on_study_desk-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/book_on_study_desk-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/book_on_study_desk-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/book_on_study_desk-600.webp"
      }
    ]
  },
  "/img/scenes/ft_salon_service_wide": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ft_salon_service_wide-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/ft_salon_service_wide-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ft_salon_service_wide-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/ft_salon_service_wide-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ft_salon_service_wide-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/ft_salon_service_wide-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_06_about_hands": {
    "width": 1600,
    "height": 686,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 686,
        "src": "/img/scenes/rs_bell_06_about_hands-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 686,
        "src": "/img/scenes/rs_bell_06_about_hands-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 429,
        "src": "/img/scenes/rs_bell_06_about_hands-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 429,
        "src": "/img/scenes/rs_bell_06_about_hands-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 257,
        "src": "/img/scenes/rs_bell_06_about_hands-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 257,
        "src": "/img/scenes/rs_bell_06_about_hands-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_07_corporate_training": {
    "width": 1600,
    "height": 789,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 789,
        "src": "/img/scenes/rs_bell_07_corporate_training-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 789,
        "src": "/img/scenes/rs_bell_07_corporate_training-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 493,
        "src": "/img/scenes/rs_bell_07_corporate_training-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 493,
        "src": "/img/scenes/rs_bell_07_corporate_training-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 296,
        "src": "/img/scenes/rs_bell_07_corporate_training-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 296,
        "src": "/img/scenes/rs_bell_07_corporate_training-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_08_consulting": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_08_consulting-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_08_consulting-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_08_consulting-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_08_consulting-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_08_consulting-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_08_consulting-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_10_office_exterior": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_10_office_exterior-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_10_office_exterior-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_10_office_exterior-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_10_office_exterior-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_10_office_exterior-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_10_office_exterior-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_11_founding": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_11_founding-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_11_founding-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_11_founding-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_11_founding-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_11_founding-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_11_founding-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_08_access_hero": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_08_access_hero-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_08_access_hero-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_08_access_hero-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_08_access_hero-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_08_access_hero-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_08_access_hero-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_09_cert_associate": {
    "width": 1600,
    "height": 1200,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_09_cert_associate-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_09_cert_associate-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_09_cert_associate-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_09_cert_associate-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_09_cert_associate-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_09_cert_associate-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_10_association_cert": {
    "width": 1600,
    "height": 1200,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_10_association_cert-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_10_association_cert-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_10_association_cert-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_10_association_cert-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_10_association_cert-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_10_association_cert-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_08_company_salon": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_08_company_salon-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_08_company_salon-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_08_company_salon-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_08_company_salon-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_08_company_salon-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_08_company_salon-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_09_butlers_hero": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_09_butlers_hero-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_09_butlers_hero-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_09_butlers_hero-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_09_butlers_hero-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_09_butlers_hero-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_09_butlers_hero-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_10_home_cta_door": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_10_home_cta_door-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_10_home_cta_door-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_10_home_cta_door-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_10_home_cta_door-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_10_home_cta_door-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_10_home_cta_door-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_12_heritage_still": {
    "width": 1600,
    "height": 1600,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1600,
        "src": "/img/scenes/rs_association_12_heritage_still-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1600,
        "src": "/img/scenes/rs_association_12_heritage_still-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1000,
        "src": "/img/scenes/rs_association_12_heritage_still-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1000,
        "src": "/img/scenes/rs_association_12_heritage_still-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 600,
        "src": "/img/scenes/rs_association_12_heritage_still-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 600,
        "src": "/img/scenes/rs_association_12_heritage_still-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_13_qual_homestudy": {
    "width": 1600,
    "height": 1600,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1600,
        "src": "/img/scenes/rs_association_13_qual_homestudy-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1600,
        "src": "/img/scenes/rs_association_13_qual_homestudy-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1000,
        "src": "/img/scenes/rs_association_13_qual_homestudy-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1000,
        "src": "/img/scenes/rs_association_13_qual_homestudy-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 600,
        "src": "/img/scenes/rs_association_13_qual_homestudy-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 600,
        "src": "/img/scenes/rs_association_13_qual_homestudy-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_14_salon_hall": {
    "width": 1600,
    "height": 1600,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1600,
        "src": "/img/scenes/rs_association_14_salon_hall-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1600,
        "src": "/img/scenes/rs_association_14_salon_hall-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1000,
        "src": "/img/scenes/rs_association_14_salon_hall-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1000,
        "src": "/img/scenes/rs_association_14_salon_hall-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 600,
        "src": "/img/scenes/rs_association_14_salon_hall-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 600,
        "src": "/img/scenes/rs_association_14_salon_hall-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_11_event_reception_entrance": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_11_event_reception_entrance-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_11_event_reception_entrance-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_11_event_reception_entrance-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_11_event_reception_entrance-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_11_event_reception_entrance-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_11_event_reception_entrance-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_12_family_support": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_12_family_support-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_12_family_support-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_12_family_support-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_12_family_support-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_12_family_support-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_12_family_support-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_13_footman_first_visit": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_13_footman_first_visit-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_13_footman_first_visit-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_13_footman_first_visit-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_13_footman_first_visit-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_13_footman_first_visit-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_13_footman_first_visit-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_14_ranks_hierarchy": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_14_ranks_hierarchy-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_14_ranks_hierarchy-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_14_ranks_hierarchy-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_14_ranks_hierarchy-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_14_ranks_hierarchy-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_14_ranks_hierarchy-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_15_villa_arrival": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_15_villa_arrival-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_15_villa_arrival-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_15_villa_arrival-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_15_villa_arrival-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_15_villa_arrival-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_15_villa_arrival-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_11_essential_hero": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_11_essential_hero-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_11_essential_hero-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_11_essential_hero-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_11_essential_hero-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_11_essential_hero-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_11_essential_hero-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_12_consultation": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rs_academy_12_consultation-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rs_academy_12_consultation-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rs_academy_12_consultation-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rs_academy_12_consultation-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_academy_12_consultation-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_academy_12_consultation-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_13_master_hero": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_13_master_hero-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_13_master_hero-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_13_master_hero-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_13_master_hero-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_13_master_hero-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_13_master_hero-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_14_advanced_hero": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_14_advanced_hero-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_14_advanced_hero-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_14_advanced_hero-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_14_advanced_hero-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_14_advanced_hero-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_14_advanced_hero-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_15_seminar_hero": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_15_seminar_hero-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_15_seminar_hero-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_15_seminar_hero-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_15_seminar_hero-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_15_seminar_hero-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_15_seminar_hero-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_09_gloves_cup": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/rs_bell_09_gloves_cup-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/rs_bell_09_gloves_cup-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/rs_bell_09_gloves_cup-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/rs_bell_09_gloves_cup-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_09_gloves_cup-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_09_gloves_cup-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_10_setting_table": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/rs_bell_10_setting_table-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/scenes/rs_bell_10_setting_table-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/rs_bell_10_setting_table-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 666,
        "src": "/img/scenes/rs_bell_10_setting_table-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_10_setting_table-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_10_setting_table-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_11_media_studio": {
    "width": 1600,
    "height": 893,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 893,
        "src": "/img/scenes/rs_bell_11_media_studio-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 893,
        "src": "/img/scenes/rs_bell_11_media_studio-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 558,
        "src": "/img/scenes/rs_bell_11_media_studio-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 558,
        "src": "/img/scenes/rs_bell_11_media_studio-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 335,
        "src": "/img/scenes/rs_bell_11_media_studio-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 335,
        "src": "/img/scenes/rs_bell_11_media_studio-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_12_book_billboard": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rs_bell_12_book_billboard-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rs_bell_12_book_billboard-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rs_bell_12_book_billboard-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rs_bell_12_book_billboard-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_12_book_billboard-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_12_book_billboard-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_13_book_cover": {
    "width": 408,
    "height": 600,
    "variants": [
      {
        "format": "jpg",
        "width": 408,
        "height": 600,
        "src": "/img/scenes/rs_bell_13_book_cover-408.jpg"
      },
      {
        "format": "webp",
        "width": 408,
        "height": 600,
        "src": "/img/scenes/rs_bell_13_book_cover-408.webp"
      }
    ]
  },
  "/img/scenes/rs_association_15_conduct_posture": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_15_conduct_posture-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_15_conduct_posture-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_15_conduct_posture-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_15_conduct_posture-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_15_conduct_posture-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_15_conduct_posture-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_16_confidentiality": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_16_confidentiality-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_16_confidentiality-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_16_confidentiality-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_16_confidentiality-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_16_confidentiality-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_16_confidentiality-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_17_crisis_briefing": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_17_crisis_briefing-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_17_crisis_briefing-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_17_crisis_briefing-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_17_crisis_briefing-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_17_crisis_briefing-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_17_crisis_briefing-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_18_certification_basic": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_18_certification_basic-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_18_certification_basic-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_18_certification_basic-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_18_certification_basic-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_18_certification_basic-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_18_certification_basic-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_19_grooming_attire": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_19_grooming_attire-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_19_grooming_attire-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_19_grooming_attire-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_19_grooming_attire-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_19_grooming_attire-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_19_grooming_attire-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_20_ai_human_judgment": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_20_ai_human_judgment-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_20_ai_human_judgment-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_20_ai_human_judgment-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_20_ai_human_judgment-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_20_ai_human_judgment-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_20_ai_human_judgment-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_16_business_doorman": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_16_business_doorman-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_16_business_doorman-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_16_business_doorman-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_16_business_doorman-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_16_business_doorman-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_16_business_doorman-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_17_enterprise_seating": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_17_enterprise_seating-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_17_enterprise_seating-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_17_enterprise_seating-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_17_enterprise_seating-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_17_enterprise_seating-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_17_enterprise_seating-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_18_wine_service": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_18_wine_service-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_18_wine_service-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_18_wine_service-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_18_wine_service-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_18_wine_service-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_18_wine_service-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_19_department_store": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_19_department_store-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_19_department_store-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_19_department_store-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_19_department_store-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_19_department_store-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_19_department_store-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_20_footman_drinks": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_20_footman_drinks-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_20_footman_drinks-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_20_footman_drinks-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_20_footman_drinks-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_20_footman_drinks-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_20_footman_drinks-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_16_campus": {
    "width": 1600,
    "height": 1200,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_16_campus-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_16_campus-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_16_campus-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_16_campus-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_16_campus-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_16_campus-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_17_roleplay": {
    "width": 1600,
    "height": 1200,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_17_roleplay-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_17_roleplay-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_17_roleplay-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_17_roleplay-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_17_roleplay-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_17_roleplay-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_18_wine_facility": {
    "width": 1600,
    "height": 1200,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_18_wine_facility-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_18_wine_facility-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_18_wine_facility-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_18_wine_facility-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_18_wine_facility-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_18_wine_facility-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_19_white_gloves": {
    "width": 1600,
    "height": 1200,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_19_white_gloves-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_19_white_gloves-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_19_white_gloves-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_19_white_gloves-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_19_white_gloves-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_19_white_gloves-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_20_pin_badge": {
    "width": 1600,
    "height": 1200,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_20_pin_badge-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_20_pin_badge-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_20_pin_badge-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_20_pin_badge-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_20_pin_badge-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_20_pin_badge-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_21_cert_professional": {
    "width": 1600,
    "height": 1200,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_21_cert_professional-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_21_cert_professional-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_21_cert_professional-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_21_cert_professional-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_21_cert_professional-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_21_cert_professional-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_14_skills_polish": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rs_bell_14_skills_polish-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rs_bell_14_skills_polish-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rs_bell_14_skills_polish-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rs_bell_14_skills_polish-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_14_skills_polish-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_14_skills_polish-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_15_chairman": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_15_chairman-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_15_chairman-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_15_chairman-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_15_chairman-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_15_chairman-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_15_chairman-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_16_appearance": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rs_bell_16_appearance-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/scenes/rs_bell_16_appearance-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rs_bell_16_appearance-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 667,
        "src": "/img/scenes/rs_bell_16_appearance-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_16_appearance-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 400,
        "src": "/img/scenes/rs_bell_16_appearance-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_17_blog_global": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_17_blog_global-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_17_blog_global-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_17_blog_global-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_17_blog_global-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_17_blog_global-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_17_blog_global-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_18_media_tv": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_18_media_tv-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_18_media_tv-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_18_media_tv-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_18_media_tv-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_18_media_tv-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_18_media_tv-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_19_media_press": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_19_media_press-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_19_media_press-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_19_media_press-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_19_media_press-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_19_media_press-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_19_media_press-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_20_lectures": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_20_lectures-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_20_lectures-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_20_lectures-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_20_lectures-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_20_lectures-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_20_lectures-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_21_deportment_standing": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_21_deportment_standing-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_21_deportment_standing-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_21_deportment_standing-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_21_deportment_standing-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_21_deportment_standing-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_21_deportment_standing-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_22_record_handover": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_22_record_handover-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_22_record_handover-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_22_record_handover-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_22_record_handover-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_22_record_handover-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_22_record_handover-600.webp"
      }
    ]
  },
  "/img/scenes/rs_association_23_senior_guidance": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_23_senior_guidance-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_association_23_senior_guidance-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_23_senior_guidance-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_association_23_senior_guidance-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_23_senior_guidance-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_association_23_senior_guidance-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_21_formal_dining_table": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_21_formal_dining_table-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_21_formal_dining_table-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_21_formal_dining_table-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_21_formal_dining_table-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_21_formal_dining_table-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_21_formal_dining_table-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_22_service_training": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_22_service_training-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_22_service_training-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_22_service_training-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_22_service_training-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_22_service_training-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_22_service_training-600.webp"
      }
    ]
  },
  "/img/scenes/rs_thebutler_23_personal_lesson": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_23_personal_lesson-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_thebutler_23_personal_lesson-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_23_personal_lesson-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_thebutler_23_personal_lesson-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_23_personal_lesson-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_thebutler_23_personal_lesson-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_22_roleplay_practice": {
    "width": 1600,
    "height": 1040,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1040,
        "src": "/img/scenes/rs_academy_22_roleplay_practice-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1040,
        "src": "/img/scenes/rs_academy_22_roleplay_practice-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 650,
        "src": "/img/scenes/rs_academy_22_roleplay_practice-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 650,
        "src": "/img/scenes/rs_academy_22_roleplay_practice-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 390,
        "src": "/img/scenes/rs_academy_22_roleplay_practice-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 390,
        "src": "/img/scenes/rs_academy_22_roleplay_practice-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_24_lecture_room": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_24_lecture_room-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_academy_24_lecture_room-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_24_lecture_room-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_academy_24_lecture_room-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_24_lecture_room-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_academy_24_lecture_room-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_21_career_study": {
    "width": 1600,
    "height": 2133,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 2133,
        "src": "/img/scenes/rs_bell_21_career_study-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 2133,
        "src": "/img/scenes/rs_bell_21_career_study-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 1333,
        "src": "/img/scenes/rs_bell_21_career_study-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 1333,
        "src": "/img/scenes/rs_bell_21_career_study-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 800,
        "src": "/img/scenes/rs_bell_21_career_study-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 800,
        "src": "/img/scenes/rs_bell_21_career_study-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_22_philosophy_window": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_22_philosophy_window-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_22_philosophy_window-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_22_philosophy_window-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_22_philosophy_window-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_22_philosophy_window-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_22_philosophy_window-600.webp"
      }
    ]
  },
  "/img/scenes/rs_bell_23_media_radio": {
    "width": 1600,
    "height": 900,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_23_media_radio-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 900,
        "src": "/img/scenes/rs_bell_23_media_radio-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_23_media_radio-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 563,
        "src": "/img/scenes/rs_bell_23_media_radio-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_23_media_radio-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 338,
        "src": "/img/scenes/rs_bell_23_media_radio-600.webp"
      }
    ]
  },
  "/img/scenes/rs_academy_25_classroom": {
    "width": 1600,
    "height": 1200,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_25_classroom-1600.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1200,
        "src": "/img/scenes/rs_academy_25_classroom-1600.webp"
      },
      {
        "format": "jpg",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_25_classroom-1000.jpg"
      },
      {
        "format": "webp",
        "width": 1000,
        "height": 750,
        "src": "/img/scenes/rs_academy_25_classroom-1000.webp"
      },
      {
        "format": "jpg",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_25_classroom-600.jpg"
      },
      {
        "format": "webp",
        "width": 600,
        "height": 450,
        "src": "/img/scenes/rs_academy_25_classroom-600.webp"
      }
    ]
  },
  "/img/catalog/a08": {
    "width": 1536,
    "height": 1024,
    "variants": [
      {
        "format": "jpg",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/a08.jpg"
      },
      {
        "format": "webp",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/a08.webp"
      }
    ]
  },
  "/img/catalog/b01": {
    "width": 1536,
    "height": 1024,
    "variants": [
      {
        "format": "jpg",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/b01.jpg"
      },
      {
        "format": "webp",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/b01.webp"
      }
    ]
  },
  "/img/catalog/bedroom": {
    "width": 1067,
    "height": 1600,
    "variants": [
      {
        "format": "jpg",
        "width": 1067,
        "height": 1600,
        "src": "/img/catalog/bedroom.jpg"
      },
      {
        "format": "webp",
        "width": 1067,
        "height": 1600,
        "src": "/img/catalog/bedroom.webp"
      }
    ]
  },
  "/img/catalog/cabinet": {
    "width": 1067,
    "height": 1600,
    "variants": [
      {
        "format": "jpg",
        "width": 1067,
        "height": 1600,
        "src": "/img/catalog/cabinet.jpg"
      },
      {
        "format": "webp",
        "width": 1067,
        "height": 1600,
        "src": "/img/catalog/cabinet.webp"
      }
    ]
  },
  "/img/catalog/candle": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/catalog/candle.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/catalog/candle.webp"
      }
    ]
  },
  "/img/catalog/cup": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/cup.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/cup.webp"
      }
    ]
  },
  "/img/catalog/desk": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/catalog/desk.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/catalog/desk.webp"
      }
    ]
  },
  "/img/catalog/dining": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/dining.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/dining.webp"
      }
    ]
  },
  "/img/catalog/door": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/door.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/door.webp"
      }
    ]
  },
  "/img/catalog/f01": {
    "width": 1536,
    "height": 1024,
    "variants": [
      {
        "format": "jpg",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/f01.jpg"
      },
      {
        "format": "webp",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/f01.webp"
      }
    ]
  },
  "/img/catalog/f10": {
    "width": 1536,
    "height": 1024,
    "variants": [
      {
        "format": "jpg",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/f10.jpg"
      },
      {
        "format": "webp",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/f10.webp"
      }
    ]
  },
  "/img/catalog/f12": {
    "width": 1024,
    "height": 1536,
    "variants": [
      {
        "format": "jpg",
        "width": 1024,
        "height": 1536,
        "src": "/img/catalog/f12.jpg"
      },
      {
        "format": "webp",
        "width": 1024,
        "height": 1536,
        "src": "/img/catalog/f12.webp"
      }
    ]
  },
  "/img/catalog/glove": {
    "width": 901,
    "height": 1600,
    "variants": [
      {
        "format": "jpg",
        "width": 901,
        "height": 1600,
        "src": "/img/catalog/glove.jpg"
      },
      {
        "format": "webp",
        "width": 901,
        "height": 1600,
        "src": "/img/catalog/glove.webp"
      }
    ]
  },
  "/img/catalog/gram": {
    "width": 901,
    "height": 1600,
    "variants": [
      {
        "format": "jpg",
        "width": 901,
        "height": 1600,
        "src": "/img/catalog/gram.jpg"
      },
      {
        "format": "webp",
        "width": 901,
        "height": 1600,
        "src": "/img/catalog/gram.webp"
      }
    ]
  },
  "/img/catalog/hall": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/hall.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/hall.webp"
      }
    ]
  },
  "/img/catalog/hat": {
    "width": 1600,
    "height": 1066,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1066,
        "src": "/img/catalog/hat.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1066,
        "src": "/img/catalog/hat.webp"
      }
    ]
  },
  "/img/catalog/lounge": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/lounge.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/lounge.webp"
      }
    ]
  },
  "/img/catalog/mirror": {
    "width": 901,
    "height": 1600,
    "variants": [
      {
        "format": "jpg",
        "width": 901,
        "height": 1600,
        "src": "/img/catalog/mirror.jpg"
      },
      {
        "format": "webp",
        "width": 901,
        "height": 1600,
        "src": "/img/catalog/mirror.webp"
      }
    ]
  },
  "/img/catalog/plates": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/catalog/plates.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/catalog/plates.webp"
      }
    ]
  },
  "/img/catalog/s01": {
    "width": 1536,
    "height": 1024,
    "variants": [
      {
        "format": "jpg",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/s01.jpg"
      },
      {
        "format": "webp",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/s01.webp"
      }
    ]
  },
  "/img/catalog/s02": {
    "width": 1536,
    "height": 1024,
    "variants": [
      {
        "format": "jpg",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/s02.jpg"
      },
      {
        "format": "webp",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/s02.webp"
      }
    ]
  },
  "/img/catalog/s03": {
    "width": 1536,
    "height": 1024,
    "variants": [
      {
        "format": "jpg",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/s03.jpg"
      },
      {
        "format": "webp",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/s03.webp"
      }
    ]
  },
  "/img/catalog/s04": {
    "width": 1536,
    "height": 1024,
    "variants": [
      {
        "format": "jpg",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/s04.jpg"
      },
      {
        "format": "webp",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/s04.webp"
      }
    ]
  },
  "/img/catalog/s16": {
    "width": 1536,
    "height": 1024,
    "variants": [
      {
        "format": "jpg",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/s16.jpg"
      },
      {
        "format": "webp",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/s16.webp"
      }
    ]
  },
  "/img/catalog/s19": {
    "width": 1024,
    "height": 1536,
    "variants": [
      {
        "format": "jpg",
        "width": 1024,
        "height": 1536,
        "src": "/img/catalog/s19.jpg"
      },
      {
        "format": "webp",
        "width": 1024,
        "height": 1536,
        "src": "/img/catalog/s19.webp"
      }
    ]
  },
  "/img/catalog/s20": {
    "width": 1536,
    "height": 1024,
    "variants": [
      {
        "format": "jpg",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/s20.jpg"
      },
      {
        "format": "webp",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/s20.webp"
      }
    ]
  },
  "/img/catalog/s24": {
    "width": 1536,
    "height": 1024,
    "variants": [
      {
        "format": "jpg",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/s24.jpg"
      },
      {
        "format": "webp",
        "width": 1536,
        "height": 1024,
        "src": "/img/catalog/s24.webp"
      }
    ]
  },
  "/img/catalog/set": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/set.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/set.webp"
      }
    ]
  },
  "/img/catalog/sheep": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/catalog/sheep.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/catalog/sheep.webp"
      }
    ]
  },
  "/img/catalog/shelf": {
    "width": 1600,
    "height": 901,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 901,
        "src": "/img/catalog/shelf.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 901,
        "src": "/img/catalog/shelf.webp"
      }
    ]
  },
  "/img/catalog/silver": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/silver.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/silver.webp"
      }
    ]
  },
  "/img/catalog/stand": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/stand.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/stand.webp"
      }
    ]
  },
  "/img/catalog/tea": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/tea.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/tea.webp"
      }
    ]
  },
  "/img/catalog/tray": {
    "width": 1600,
    "height": 1067,
    "variants": [
      {
        "format": "jpg",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/tray.jpg"
      },
      {
        "format": "webp",
        "width": 1600,
        "height": 1067,
        "src": "/img/catalog/tray.webp"
      }
    ]
  },
  "/img/catalog/wardrobe": {
    "width": 901,
    "height": 1600,
    "variants": [
      {
        "format": "jpg",
        "width": 901,
        "height": 1600,
        "src": "/img/catalog/wardrobe.jpg"
      },
      {
        "format": "webp",
        "width": 901,
        "height": 1600,
        "src": "/img/catalog/wardrobe.webp"
      }
    ]
  },
  "/img/catalog/watch": {
    "width": 1067,
    "height": 1600,
    "variants": [
      {
        "format": "jpg",
        "width": 1067,
        "height": 1600,
        "src": "/img/catalog/watch.jpg"
      },
      {
        "format": "webp",
        "width": 1067,
        "height": 1600,
        "src": "/img/catalog/watch.webp"
      }
    ]
  }
} as const
